// This file is auto-generated by @hey-api/openapi-ts

export type AccountingBalanceSheetMetrics = {
    totalAssets?: number;
    totalLiabilities?: number;
    ar30Days?: number;
    ar3160Days?: number;
    ar6190Days?: number;
    ar90PlusDays?: number;
    ap30Days?: number;
    ap3160Days?: number;
    ap6190Days?: number;
    ap90PlusDays?: number;
};

export type AccountingProfitLossMetricsReport = {
    trailingTwelveMonthsMetrics?: YearProfitLossMetrics;
    yearToDateMetrics?: YearProfitLossMetrics;
    yearProfitLossMetrics?: Array<YearProfitLossMetrics> | null;
};

export type AccountingReportResult = {
    reportType?: (string) | null;
    accrualProfitLoss?: ProfitLossReport;
    cashProfitLoss?: ProfitLossReport;
    accountsRecievable?: AccountsReport;
    accountsPayable?: AccountsReport;
    balanceSheet?: BalanceSheetReport;
};

export type AccountsReport = {
    timestamp?: string;
    accounts?: AccountsReportEntry;
};

export type AccountsReportEntry = {
    name?: (string) | null;
    total90Plus?: number;
    total6190?: number;
    total3160?: number;
    total30?: number;
    current?: number;
    total?: number;
    subEntries?: Array<AccountsReportEntry> | null;
};

export type AdditionLenderAddRequest = {
    lenderIds?: Array<(string)> | null;
};

export type AdditionalDebt = {
    debtType?: LoanType;
    lender?: (string) | null;
    initialAmount?: (number) | null;
    position?: (number) | null;
    remainingAmount?: (number) | null;
    monthlyPayment?: (number) | null;
    maturityDate?: (number) | null;
    startDate?: (number) | null;
    interestRate?: (number) | null;
    collateral?: Array<DebtCollateral> | null;
};

export type AdditionalFileState = 'Submitted' | 'Approved';

export const AdditionalFileState = {
    SUBMITTED: 'Submitted',
    APPROVED: 'Approved'
} as const;

export type AdditionalFileViewModel = {
    file?: FileViewModel;
    state?: AdditionalFileState;
    uploadedPortal?: PortalType;
    approvedLenders?: Array<(string)> | null;
    lenderName?: (string) | null;
};

export type Address = {
    line1?: (string) | null;
    line2?: (string) | null;
    city?: (string) | null;
    state?: (string) | null;
    zipCode?: (string) | null;
};

export type ApplicationAuditEvent = 'AppCreated' | 'AppStatusUpdated' | 'AppCloseDateUpdated' | 'AppAttested' | 'AppAskUpdated' | 'AppSubmitted' | 'AppSpecialistAssigned' | 'AppAddedLenderDueToMatching' | 'AppAddedLenderManually' | 'AppSubmissionDenied' | 'AppSubmissionApproved' | 'AppCancelled' | 'AppNotFunded' | 'AppDeveloperOverrideStatus' | 'AppOnHold' | 'AppOffHold' | 'PreviewViewed' | 'AnonymousPreviewViewed';

export const ApplicationAuditEvent = {
    APP_CREATED: 'AppCreated',
    APP_STATUS_UPDATED: 'AppStatusUpdated',
    APP_CLOSE_DATE_UPDATED: 'AppCloseDateUpdated',
    APP_ATTESTED: 'AppAttested',
    APP_ASK_UPDATED: 'AppAskUpdated',
    APP_SUBMITTED: 'AppSubmitted',
    APP_SPECIALIST_ASSIGNED: 'AppSpecialistAssigned',
    APP_ADDED_LENDER_DUE_TO_MATCHING: 'AppAddedLenderDueToMatching',
    APP_ADDED_LENDER_MANUALLY: 'AppAddedLenderManually',
    APP_SUBMISSION_DENIED: 'AppSubmissionDenied',
    APP_SUBMISSION_APPROVED: 'AppSubmissionApproved',
    APP_CANCELLED: 'AppCancelled',
    APP_NOT_FUNDED: 'AppNotFunded',
    APP_DEVELOPER_OVERRIDE_STATUS: 'AppDeveloperOverrideStatus',
    APP_ON_HOLD: 'AppOnHold',
    APP_OFF_HOLD: 'AppOffHold',
    PREVIEW_VIEWED: 'PreviewViewed',
    ANONYMOUS_PREVIEW_VIEWED: 'AnonymousPreviewViewed'
} as const;

export type AttachmentViewModel = {
    attachmentName?: (string) | null;
    attachmentId?: (string) | null;
    attachmentApplicationFileId?: number;
};

export type AuditViewModel = {
    loanId?: (string) | null;
    loanName?: (string) | null;
    lender?: LenderViewModel;
    applicationAuditEvent?: ApplicationAuditEvent;
    lenderApplicationAuditEvent?: LenderApplicationAuditEvent;
    user?: UserViewModel;
    description?: (string) | null;
    timestamp?: (number) | null;
};

export type BalanceSheetMetrics = {
    mostRecentBalanceSheetFile?: (string) | null;
    mostRecentBalanceSheetFiles?: Array<(string)> | null;
    previousYearsBalanceSheetFiles?: Array<(string)> | null;
    balanceSheetAsOfDate?: (number) | null;
    currentCash?: (number) | null;
    currentAssets?: (number) | null;
    totalAssets?: (number) | null;
    currentLiabilities?: (number) | null;
    totalLiabilities?: (number) | null;
    totalUnencumberedAssets?: (number) | null;
    accountsReceivableScheduleFile?: (string) | null;
    accountsReceivableScheduleFiles?: Array<(string)> | null;
    accountsReceivableTotal?: (number) | null;
    accountsReceivable30Days?: (number) | null;
    accountsReceivable3160Days?: (number) | null;
    accountsReceivable6190Days?: (number) | null;
    accountsReceivable90PlusDays?: (number) | null;
    inventoryOver500k?: (boolean) | null;
    inventoryAmount?: (number) | null;
    inventorySupportingFiles?: Array<(string)> | null;
    inventoryBreakdownFiles?: Array<(string)> | null;
    inventoryBreakdownFile?: (string) | null;
    equipmentOver500k?: (boolean) | null;
    estEquipmentValue?: (number) | null;
    equipmentBreakdownFiles?: Array<(string)> | null;
    equipmentBreakdownFile?: (string) | null;
    equipmentExternalAppraisalFiles?: Array<(string)> | null;
    equipmentExternalAppraisalFile?: (string) | null;
    hasEquipmentDebt?: (boolean) | null;
    totalDebtSecuredByEquipment?: (number) | null;
    realEstateOver500k?: (boolean) | null;
    estRealEstateValue?: (number) | null;
    realEstateBreakdownFiles?: Array<(string)> | null;
    realEstateBreakdownFile?: (string) | null;
    realEstateExternalAppraisalFiles?: Array<(string)> | null;
    realEstateExternalAppraisalFile?: (string) | null;
    hasRealEstateDebt?: (boolean) | null;
    totalMortgages?: (number) | null;
    accountsPayableScheduleFile?: (string) | null;
    accountsPayableScheduleFiles?: Array<(string)> | null;
    accountsPayable30Days?: (number) | null;
    accountsPayable3160Days?: (number) | null;
    accountsPayable6190Days?: (number) | null;
    accountsPayable90PlusDays?: (number) | null;
    accountsPayableTotal?: (number) | null;
    hasAdditionalDebt?: (boolean) | null;
    totalAdditionalDebt?: (number) | null;
    additionalDebtScheduleFile?: (string) | null;
    additionalDebtScheduleFiles?: Array<(string)> | null;
    totalDebt?: (number) | null;
    additionalDebt?: Array<AdditionalDebt> | null;
};

export type BalanceSheetReport = {
    timestamp?: string;
    assets?: ReportEntry;
    liability?: ReportEntry;
    equity?: ReportEntry;
};

export type BorrowerAccess = 'Admin' | 'Editor' | 'ReadOnly';

export const BorrowerAccess = {
    ADMIN: 'Admin',
    EDITOR: 'Editor',
    READ_ONLY: 'ReadOnly'
} as const;

export type BorrowerContextViewModel = {
    borrowers?: Array<BorrowerViewModel> | null;
    activeLoanId?: (string) | null;
    activeBorrowerId?: (string) | null;
    activeBorrowerAccess?: BorrowerAccess;
};

export type BorrowerProfile = {
    companyInformation?: CompanyInformation;
    loanAsk?: LoanAsk;
    profitLossMetrics?: ProfitLossMetrics;
    taxInformation?: TaxInformation;
    balanceSheetMetrics?: BalanceSheetMetrics;
    additionalDocs?: Array<(string)> | null;
};

export type BorrowerUserViewModel = {
    user?: UserViewModel;
    borrowerAccess?: BorrowerAccess;
};

export type BorrowerViewModel = {
    id?: (string) | null;
    referralTag?: (string) | null;
    activeLoanApplication?: (string) | null;
    quickbooksConnected?: boolean;
    lastQuickbooksReportGenerated?: (string) | null;
    plaidConnected?: boolean;
    lastPlaidTransactionSync?: (string) | null;
    profile?: BorrowerProfile;
    user?: UserViewModel;
    companyName?: (string) | null;
    borrowerAccess?: BorrowerAccess;
    termsAccepted?: boolean;
    createdAt?: (string) | null;
    onboardingState?: number;
    loans?: Array<LoanApplicationViewModel> | null;
};

export type CollateralType = 'Equipment' | 'Receivables' | 'RealEstate' | 'Inventory';

export const CollateralType = {
    EQUIPMENT: 'Equipment',
    RECEIVABLES: 'Receivables',
    REAL_ESTATE: 'RealEstate',
    INVENTORY: 'Inventory'
} as const;

export type CompanyInformation = {
    companyName?: (string) | null;
    yearFormed?: (number) | null;
    stage?: CompanyStage;
    hasMoreThan3MonthsRunway?: (boolean) | null;
    companyType?: CompanyType;
    headQuartersAddress?: Address;
    companyPhone?: (string) | null;
    realEstateCompliance?: (string) | null;
    realEstateComplianceUpload?: (string) | null;
    companyWebsite?: (string) | null;
    numberOfEmployees?: (string) | null;
    businessDescription?: (string) | null;
    industry?: (string) | null;
    subIndustry?: (string) | null;
    employerIdentificationNumber?: (string) | null;
    veteranOwned?: (boolean) | null;
    femaleOwned?: (boolean) | null;
    disabilityOwned?: (boolean) | null;
    minorityOwned?: (boolean) | null;
    businessPlanFile?: (string) | null;
    businessPlanFiles?: Array<(string)> | null;
    quickbooksAccessToken?: (string) | null;
    quickbooksAccessTokenExpiration?: string;
    quickbooksRefreshToken?: (string) | null;
    quickbooksRefreshTokenExpiration?: string;
    orgChartFile?: (string) | null;
    orgChartFiles?: Array<(string)> | null;
    growthPlansDescription?: (string) | null;
    primaryContact?: Contact;
    secondaryContacts?: Array<Contact> | null;
    officers?: Array<Officer> | null;
    nonManagementShareholdersOverTenPercent?: (boolean) | null;
    revenueMix?: Array<RevenueMix> | null;
    descriptionOfCustomers?: (string) | null;
    totalRevenuePercentOfTopFiveCustomers?: (number) | null;
    customerContractFiles?: Array<(string)> | null;
};

export type CompanyStage = 'Early' | 'Growth' | 'Mature';

export const CompanyStage = {
    EARLY: 'Early',
    GROWTH: 'Growth',
    MATURE: 'Mature'
} as const;

export type CompanyType = 'LLC' | 'SCorp' | 'CCorp' | 'Partnership' | 'SoleProprietorship';

export const CompanyType = {
    LLC: 'LLC',
    SCORP: 'SCorp',
    CCORP: 'CCorp',
    PARTNERSHIP: 'Partnership',
    SOLE_PROPRIETORSHIP: 'SoleProprietorship'
} as const;

export type Contact = {
    firstName?: (string) | null;
    lastName?: (string) | null;
    title?: (string) | null;
    email?: (string) | null;
    phoneNumber?: (string) | null;
};

export type Counterparty = {
    name?: (string) | null;
    entity_id?: (string) | null;
    type?: CounterpartyType;
    website?: (string) | null;
    logo_url?: (string) | null;
    confidence_level?: (string) | null;
};

export type CounterpartyType = 'Merchant' | 'FinancialInstitution' | 'PaymentApp' | 'Marketplace' | 'PaymentTerminal' | 'IncomeSource' | 'Undefined';

export const CounterpartyType = {
    MERCHANT: 'Merchant',
    FINANCIAL_INSTITUTION: 'FinancialInstitution',
    PAYMENT_APP: 'PaymentApp',
    MARKETPLACE: 'Marketplace',
    PAYMENT_TERMINAL: 'PaymentTerminal',
    INCOME_SOURCE: 'IncomeSource',
    UNDEFINED: 'Undefined'
} as const;

export type CovenantViewModel = {
    id?: number;
    name?: (string) | null;
};

export type CustomMetricFormat = 'Ratio' | 'Currency' | 'Integer' | 'Percent';

export const CustomMetricFormat = {
    RATIO: 'Ratio',
    CURRENCY: 'Currency',
    INTEGER: 'Integer',
    PERCENT: 'Percent'
} as const;

export type DebtCollateral = {
    collateralType?: CollateralType;
    initialValue?: (number) | null;
    currentValue?: (number) | null;
    lastAppraisalDate?: (number) | null;
};

export type DiligenceStatus = 'Pending' | 'Sent' | 'Received' | 'Complete';

export const DiligenceStatus = {
    PENDING: 'Pending',
    SENT: 'Sent',
    RECEIVED: 'Received',
    COMPLETE: 'Complete'
} as const;

export type EvaluationInput = {
    readonly dscr?: number;
    referralTag?: (string) | null;
    loanType?: LoanType;
    loanUse?: Array<LoanUse> | null;
    industry?: (string) | null;
    zipCode?: (string) | null;
    companyStage?: CompanyStage;
    fundingTimeline?: FundingTimeline;
    loanAmount?: number;
    currentLiabilities?: number;
    ttmNetIncome?: number;
    ttmEbitda?: number;
    ttmRevenue?: number;
    monthlyAr?: number;
    po?: number;
    avgMonthlyCash?: number;
    totalUnencumberedAssets?: number;
    totalDebt?: number;
    totalRevenue?: number;
    totalAssets?: number;
    totalEquipment?: number;
    unencumberedEquipment?: number;
    totalRealEstate?: number;
    unencumberedRealEstate?: number;
    totalInventory?: number;
    unencumberedInventory?: number;
    currentAssets?: number;
    monthlyDebtService?: number;
};

export type EvaluationResult = {
    loanApplicationId?: number;
    validationToken?: (string) | null;
    cxmScore?: (number) | null;
    rawScore?: (number) | null;
    approvalProbability?: (number) | null;
    metricAssessments?: Array<MetricAssessment> | null;
    approvalProbabilities?: Array<(number)> | null;
    matchedLenders?: number;
    matchedLendersForTargetType?: number;
    matchThreshold?: number;
    monthlyPayment?: number;
    maturityInMonths?: number;
    interestRate?: number;
    loanAmount?: (number) | null;
    inputsByQuestionId?: {
        [key: string]: ((string) | null);
    } | null;
    loanQuestions?: {
        [key: string]: ((string) | null);
    } | null;
    scoringFormulas?: {
        [key: string]: ((string) | null);
    } | null;
    scoringFormulaVariables?: {
        [key: string]: unknown;
    } | null;
    scoringFormulaResults?: {
        [key: string]: ((number) | null);
    } | null;
    scoringFunctionValues?: Array<(number)> | null;
    scoringWeights?: Array<(number)> | null;
    probabilityFormulas?: {
        [key: string]: ((string) | null);
    } | null;
    probabilityFormulaVariables?: {
        [key: string]: unknown;
    } | null;
    probabilityFormulaResults?: {
        [key: string]: ((number) | null);
    } | null;
    probabilityFunctionValues?: Array<(number)> | null;
    probabilityWeights?: {
        Abl?: Array<(number)>;
        ArFactoring?: Array<(number)>;
        Sba?: Array<(number)>;
        Equipment?: Array<(number)>;
        Sbic?: Array<(number)>;
        CashFlow?: Array<(number)>;
        JuniorMezz?: Array<(number)>;
        VentureRev?: Array<(number)>;
        Cre?: Array<(number)>;
        RealEstate?: Array<(number)>;
        Inventory?: Array<(number)>;
        Mna?: Array<(number)>;
        PurchaseOrder?: Array<(number)>;
        SbaRealEstate?: Array<(number)>;
        RevFinancing?: Array<(number)>;
        AllLoans?: Array<(number)>;
    } | null;
    bestMatchLoanType?: LoanType;
    debugLenderList?: Array<LenderViewModel> | null;
    loanType?: LoanType;
    scoreTraceJson?: unknown;
    matchingTraceJson?: unknown;
    probabilityTraceJson?: unknown;
};

export type FileApprovalRequest = {
    [key: string]: unknown;
};

export type FileUploadResponse = {
    id?: (string) | null;
    fileName?: (string) | null;
    presignedUploadUrl?: (string) | null;
};

export type FileViewModel = {
    id?: (string) | null;
    name?: (string) | null;
    extension?: (string) | null;
    createdAt?: number;
    size?: number;
    uploadedBy?: UserViewModel;
};

export type FormulaValidationRequest = {
    formula?: (string) | null;
    rawInputs?: {
        [key: string]: ((number) | null);
    } | null;
};

export type FullLenderCriteria = {
    defaultCriteria?: LenderCriteria;
    loanTypeOverrides?: Array<LoanTypeLenderCriteria> | null;
};

export type FullLenderCriteriaResponse = {
    criteria?: FullLenderCriteria;
    loanTypes?: Array<LoanType> | null;
};

export type FundabilityImpact = 'Positive' | 'Negative';

export const FundabilityImpact = {
    POSITIVE: 'Positive',
    NEGATIVE: 'Negative'
} as const;

export type FundabilityNarrative = {
    impact?: FundabilityImpact;
    narrativeText?: (string) | null;
};

export type FundingOption = {
    loanType?: LoanType;
    lowRate?: number;
    highRate?: number;
    estimatedRate?: number;
    lowMaturity?: number;
    highMaturity?: number;
    termEstimate?: number;
    lowTime?: number;
    highTime?: number;
    lowAmount?: number;
    highAmount?: number;
    lowPayment?: number;
    highPayment?: number;
};

export type FundingTimeline = 'AsSoonAsPossible' | 'WithinOneMonth' | 'WithinThreeMonths' | 'WithinSixMonths';

export const FundingTimeline = {
    AS_SOON_AS_POSSIBLE: 'AsSoonAsPossible',
    WITHIN_ONE_MONTH: 'WithinOneMonth',
    WITHIN_THREE_MONTHS: 'WithinThreeMonths',
    WITHIN_SIX_MONTHS: 'WithinSixMonths'
} as const;

export type ITemplateResult = {
    templateType?: TemplateType;
    result?: (string) | null;
    assessment?: TemplateAssessment;
    value?: (number) | null;
};

export type Industry = 'Unknown' | 'Agriculture' | 'Mining' | 'Utilities' | 'Construction' | 'Manufacturing' | 'Wholesale_Trade' | 'Retail_Trade' | 'Transportation_and_Warehousing' | 'Information' | 'Finance_and_Insurance' | 'Real_Estate_and_Rental_and_Leasing' | 'Professional' | 'Management_of_Companies_and_Enterprises' | 'Administrative_and_Support_and_Waste_Management_and_Remediation_Services' | 'Educational_Services' | 'Health_Care_and_Social_Assistance' | 'Arts' | 'Accommodation_and_Food_Services' | 'Other_Services_except_Public_Administration' | 'Public_Administration';

export const Industry = {
    UNKNOWN: 'Unknown',
    AGRICULTURE: 'Agriculture',
    MINING: 'Mining',
    UTILITIES: 'Utilities',
    CONSTRUCTION: 'Construction',
    MANUFACTURING: 'Manufacturing',
    WHOLESALE_TRADE: 'Wholesale_Trade',
    RETAIL_TRADE: 'Retail_Trade',
    TRANSPORTATION_AND_WAREHOUSING: 'Transportation_and_Warehousing',
    INFORMATION: 'Information',
    FINANCE_AND_INSURANCE: 'Finance_and_Insurance',
    REAL_ESTATE_AND_RENTAL_AND_LEASING: 'Real_Estate_and_Rental_and_Leasing',
    PROFESSIONAL: 'Professional',
    MANAGEMENT_OF_COMPANIES_AND_ENTERPRISES: 'Management_of_Companies_and_Enterprises',
    ADMINISTRATIVE_AND_SUPPORT_AND_WASTE_MANAGEMENT_AND_REMEDIATION_SERVICES: 'Administrative_and_Support_and_Waste_Management_and_Remediation_Services',
    EDUCATIONAL_SERVICES: 'Educational_Services',
    HEALTH_CARE_AND_SOCIAL_ASSISTANCE: 'Health_Care_and_Social_Assistance',
    ARTS: 'Arts',
    ACCOMMODATION_AND_FOOD_SERVICES: 'Accommodation_and_Food_Services',
    OTHER_SERVICES_EXCEPT_PUBLIC_ADMINISTRATION: 'Other_Services_except_Public_Administration',
    PUBLIC_ADMINISTRATION: 'Public_Administration'
} as const;

export type InviteUserRequest = {
    email?: (string) | null;
    type?: (string) | null;
    firstName?: (string) | null;
    lastName?: (string) | null;
    phone?: (string) | null;
    borrowerAccessType?: BorrowerAccess;
    lenderUserType?: LenderUserType;
    lenderId?: (string) | null;
};

export type LandingEvaluationResponse = {
    matchedLenders?: {
        Abl?: number;
        ArFactoring?: number;
        Sba?: number;
        Equipment?: number;
        Sbic?: number;
        CashFlow?: number;
        JuniorMezz?: number;
        VentureRev?: number;
        Cre?: number;
        RealEstate?: number;
        Inventory?: number;
        Mna?: number;
        PurchaseOrder?: number;
        SbaRealEstate?: number;
        RevFinancing?: number;
        AllLoans?: number;
    } | null;
    fundingOptions?: Array<FundingOption> | null;
    evaluationId?: (string) | null;
    fundabilityScore?: number;
    narrative?: Array<FundabilityNarrative> | null;
    totalMatchedLenders?: number;
    matchedLenderNames?: {
        Abl?: Array<(string)>;
        ArFactoring?: Array<(string)>;
        Sba?: Array<(string)>;
        Equipment?: Array<(string)>;
        Sbic?: Array<(string)>;
        CashFlow?: Array<(string)>;
        JuniorMezz?: Array<(string)>;
        VentureRev?: Array<(string)>;
        Cre?: Array<(string)>;
        RealEstate?: Array<(string)>;
        Inventory?: Array<(string)>;
        Mna?: Array<(string)>;
        PurchaseOrder?: Array<(string)>;
        SbaRealEstate?: Array<(string)>;
        RevFinancing?: Array<(string)>;
        AllLoans?: Array<(string)>;
    } | null;
};

export type LandingLegacyEvaluationResponse = {
    id?: (string) | null;
    result?: EvaluationResult;
};

export type LandingPageEvaluation = {
    id?: number;
    updatedDateTime?: (string) | null;
    updatedDateTimeUtc?: (string) | null;
    updatedBy?: (string) | null;
    createdDateTime?: (string) | null;
    createdDateTimeUtc?: (string) | null;
    createdBy?: (string) | null;
    publicId?: (string) | null;
    fundingTimeline?: FundingTimeline;
    zipCode?: (string) | null;
    loanAmount?: number;
    loanUse?: LoanUse;
    industry?: (string) | null;
    loanType?: LoanType;
    totalDebt?: number;
    currentLiabilities?: number;
    estEquipmentValue?: number;
    unencumberedEquipment?: number;
    yearsInBusiness?: number;
    yearlyDebtService?: number;
    totalUnencumberedAssets?: number;
    currentAssets?: number;
    totalAssets?: number;
    refinanceRatio?: number;
    ttmNetIncome?: number;
    ttmRevenue?: number;
    ttmEbitda?: number;
    ar?: number;
    inventoryValue?: number;
    unencumberedInventory?: number;
    avgMonthlyCash?: number;
    estRealEstateValue?: number;
    unencumberedRealEstate?: number;
    cashBalance?: number;
    outstandingDebt?: number;
    score?: number;
    matchedLenders?: number;
    referralTag?: (string) | null;
};

export type LandingPageEvaluationViewModel = {
    publicId?: (string) | null;
    zipCode?: (string) | null;
    loanAmount?: number;
    loanUse?: LoanUse;
    industry?: (string) | null;
    loanType?: LoanType;
    currentLiabilities?: number;
    estEquipmentValue?: number;
    yearsInBusiness?: number;
    ttmRevenue?: number;
    ttmEbitda?: number;
    ar?: number;
    inventoryValue?: number;
    avgMonthlyCash?: number;
    estRealEstateValue?: number;
    cashBalance?: number;
    outstandingDebt?: number;
    referralTag?: (string) | null;
    createdAt?: (number) | null;
};

export type LenderAdminViewModel = {
    applicationAccessManagement?: LenderApplicationAccessManagement;
};

export type LenderApplicationAccessManagement = 'EveryoneHasAccess' | 'ConditionalAccess';

export const LenderApplicationAccessManagement = {
    EVERYONE_HAS_ACCESS: 'EveryoneHasAccess',
    CONDITIONAL_ACCESS: 'ConditionalAccess'
} as const;

export type LenderApplicationAuditEvent = 'Added' | 'Withdrawn' | 'SubmissionRequested' | 'SubmissionApproved' | 'SubmissionDenied' | 'Declined' | 'ExpressedInterest' | 'SubmittedBinding' | 'SubmittedNonBinding' | 'Acknowledged' | 'RequestedAdditionalInfo' | 'MarkedAwaitingLenderResponse' | 'MarkedInUnderwriting';

export const LenderApplicationAuditEvent = {
    ADDED: 'Added',
    WITHDRAWN: 'Withdrawn',
    SUBMISSION_REQUESTED: 'SubmissionRequested',
    SUBMISSION_APPROVED: 'SubmissionApproved',
    SUBMISSION_DENIED: 'SubmissionDenied',
    DECLINED: 'Declined',
    EXPRESSED_INTEREST: 'ExpressedInterest',
    SUBMITTED_BINDING: 'SubmittedBinding',
    SUBMITTED_NON_BINDING: 'SubmittedNonBinding',
    ACKNOWLEDGED: 'Acknowledged',
    REQUESTED_ADDITIONAL_INFO: 'RequestedAdditionalInfo',
    MARKED_AWAITING_LENDER_RESPONSE: 'MarkedAwaitingLenderResponse',
    MARKED_IN_UNDERWRITING: 'MarkedInUnderwriting'
} as const;

export type LenderApplicationStatus = 'Submitted' | 'Acknowledged' | 'Pursued' | 'NotPursued' | 'Declined' | 'Missed' | 'Withdrawn' | 'Unsubmitted' | 'RequestedSubmissionApproval' | 'SubmissionDenied';

export const LenderApplicationStatus = {
    SUBMITTED: 'Submitted',
    ACKNOWLEDGED: 'Acknowledged',
    PURSUED: 'Pursued',
    NOT_PURSUED: 'NotPursued',
    DECLINED: 'Declined',
    MISSED: 'Missed',
    WITHDRAWN: 'Withdrawn',
    UNSUBMITTED: 'Unsubmitted',
    REQUESTED_SUBMISSION_APPROVAL: 'RequestedSubmissionApproval',
    SUBMISSION_DENIED: 'SubmissionDenied'
} as const;

export type LenderApplicationUnderwritingState = 'WaitingLenderResponse' | 'RequestedAdditionalInfo' | 'InUnderwriting' | 'None';

export const LenderApplicationUnderwritingState = {
    WAITING_LENDER_RESPONSE: 'WaitingLenderResponse',
    REQUESTED_ADDITIONAL_INFO: 'RequestedAdditionalInfo',
    IN_UNDERWRITING: 'InUnderwriting',
    NONE: 'None'
} as const;

export type LenderContextViewModel = {
    lenders?: Array<LenderViewModel> | null;
    activeLenderName?: (string) | null;
    activeLenderUserType?: LenderUserType;
    activeLenderAccessType?: LenderApplicationAccessManagement;
    activeLenderId?: (string) | null;
};

export type LenderCriteria = {
    ttM_Revenue_Min?: (number) | null;
    ttM_Revenue_Max?: (number) | null;
    ttM_EBITDA_Min?: (number) | null;
    ttM_EBITDA_Max?: (number) | null;
    fmV_PPE_Min?: (number) | null;
    fmV_PPE_Max?: (number) | null;
    aR_Min?: (number) | null;
    aR_Max?: (number) | null;
    inventory_Min?: (number) | null;
    inventory_Max?: (number) | null;
    years_In_Business_Min?: (number) | null;
    years_In_Business_Max?: (number) | null;
    loan_Amount_Min?: (number) | null;
    loan_Amount_Max?: (number) | null;
    personal_Guarantee?: (boolean) | null;
    audit_Review?: (boolean) | null;
    external_Accountant?: (boolean) | null;
    has_CFO?: (boolean) | null;
    loan_To_Revenue_Min?: (number) | null;
    loan_To_Revenue_Max?: (number) | null;
    loan_To_EBITDA_Min?: (number) | null;
    loan_To_EBITDA_Max?: (number) | null;
    advance_AR_Rate_Min?: (number) | null;
    advance_AR_Rate_Max?: (number) | null;
    advance_Equip_Rate_Min?: (number) | null;
    advance_Equip_Rate_Max?: (number) | null;
    advance_Inventory_Rate_Min?: (number) | null;
    advance_Inventory_Rate_Max?: (number) | null;
    advance_Cash_Rate_Min?: (number) | null;
    advance_Cash_Rate_Max?: (number) | null;
    rate_Min?: (number) | null;
    rate_Max?: (number) | null;
    rate_Reference?: RateReference;
    rate_Spread_Min?: (number) | null;
    rate_Spread_Max?: (number) | null;
    maturity_Min?: (number) | null;
    maturity_Max?: (number) | null;
    equipment_Orderly_Liquidation_Min?: (number) | null;
    equipment_Orderly_Liquidation_Max?: (number) | null;
    equipment_Forced_Liquidation_Min?: (number) | null;
    equipment_Forced_Liquidation_Max?: (number) | null;
    revenue_Mixes?: Array<RevenueMix> | null;
    industries?: Array<Industry> | null;
    sub_Industries?: Array<SubIndustry> | null;
    loan_Uses?: Array<LoanUse> | null;
};

export type LenderCriteriaReportViewModel = {
    loanType?: LoanType;
    createdAt?: (string) | null;
    lenderName?: (string) | null;
    lenderCriteria?: LenderCriteria;
    supportedStates?: number;
};

export type LenderCustomMetricViewModel = {
    id?: (string) | null;
    format?: CustomMetricFormat;
    name?: (string) | null;
    formula?: (string) | null;
};

export type LenderGroupViewModel = {
    id?: (string) | null;
    name?: (string) | null;
    createdAt?: (string) | null;
};

export type LenderLoanTypeMatchFailReason = 'FailedRegion' | 'FailedLoanType' | 'FailedLoanSize' | 'FailedEbitda' | 'FailedRevenue';

export const LenderLoanTypeMatchFailReason = {
    FAILED_REGION: 'FailedRegion',
    FAILED_LOAN_TYPE: 'FailedLoanType',
    FAILED_LOAN_SIZE: 'FailedLoanSize',
    FAILED_EBITDA: 'FailedEbitda',
    FAILED_REVENUE: 'FailedRevenue'
} as const;

export type LenderLoanTypeMatchResult = {
    failReasons?: Array<LenderLoanTypeMatchFailReason> | null;
    loanType?: LoanType;
    min_Maturity?: number;
    max_Maturity?: number;
    min_Rate?: number;
    max_Rate?: number;
    min_Loan_Size?: number;
    max_Loan_Size?: number;
    matched?: boolean;
};

export type LenderMatchResult = {
    matchResult?: LenderMatchResultType;
    matchedLoanTypes?: {
        Abl?: LenderLoanTypeMatchResult;
        ArFactoring?: LenderLoanTypeMatchResult;
        Sba?: LenderLoanTypeMatchResult;
        Equipment?: LenderLoanTypeMatchResult;
        Sbic?: LenderLoanTypeMatchResult;
        CashFlow?: LenderLoanTypeMatchResult;
        JuniorMezz?: LenderLoanTypeMatchResult;
        VentureRev?: LenderLoanTypeMatchResult;
        Cre?: LenderLoanTypeMatchResult;
        RealEstate?: LenderLoanTypeMatchResult;
        Inventory?: LenderLoanTypeMatchResult;
        Mna?: LenderLoanTypeMatchResult;
        PurchaseOrder?: LenderLoanTypeMatchResult;
        SbaRealEstate?: LenderLoanTypeMatchResult;
        RevFinancing?: LenderLoanTypeMatchResult;
        AllLoans?: LenderLoanTypeMatchResult;
    } | null;
};

export type LenderMatchResultType = 'Failed' | 'FailedRegion' | 'Matched';

export const LenderMatchResultType = {
    FAILED: 'Failed',
    FAILED_REGION: 'FailedRegion',
    MATCHED: 'Matched'
} as const;

export type LenderOfferStatus = 'NoneSubmitted' | 'SpecialistReview' | 'NeedsRevision' | 'BorrowerReview' | 'Accepted' | 'Declined';

export const LenderOfferStatus = {
    NONE_SUBMITTED: 'NoneSubmitted',
    SPECIALIST_REVIEW: 'SpecialistReview',
    NEEDS_REVISION: 'NeedsRevision',
    BORROWER_REVIEW: 'BorrowerReview',
    ACCEPTED: 'Accepted',
    DECLINED: 'Declined'
} as const;

export type LenderProfileViewModel = {
    id?: (string) | null;
    region?: LenderRegionViewModel;
    altContactName?: (string) | null;
    altContactNumber?: (string) | null;
    lenderName?: (string) | null;
    businessOverview?: (string) | null;
    primaryContact?: UserViewModel;
    primaryContactId?: (number) | null;
    loanTypes?: Array<LoanType> | null;
    address?: Address;
    numberOfLocations?: number;
    typeOfInstitution?: LenderTypeOfInstitution;
    emailAddress?: (string) | null;
    loanAssetsUnderMgmt?: number;
    totalBalanceSheet?: number;
};

export type LenderRegionViewModel = {
    states?: Array<(string)> | null;
    includedZips?: (string) | null;
    excludedZips?: (string) | null;
};

export type LenderTemplateMetricViewModel = {
    id?: (string) | null;
    metricKey?: (string) | null;
    isCustom?: boolean;
    metricName?: (string) | null;
    metricOrder?: number;
};

export type LenderTemplateViewModel = {
    id?: (string) | null;
    name?: (string) | null;
    defaultForLoanTypes?: Array<LoanType> | null;
    defaultForExportLoanTypes?: Array<LoanType> | null;
    metrics?: Array<LenderTemplateMetricViewModel> | null;
};

export type LenderTypeOfInstitution = 'Local' | 'Regional' | 'Alternative' | 'CreditUnion' | 'National';

export const LenderTypeOfInstitution = {
    LOCAL: 'Local',
    REGIONAL: 'Regional',
    ALTERNATIVE: 'Alternative',
    CREDIT_UNION: 'CreditUnion',
    NATIONAL: 'National'
} as const;

export type LenderUserType = 'Admin' | 'Delegate';

export const LenderUserType = {
    ADMIN: 'Admin',
    DELEGATE: 'Delegate'
} as const;

export type LenderUserViewModel = {
    user?: UserViewModel;
    id?: number;
    lenderUserType?: LenderUserType;
    hasAccess?: boolean;
};

export type LenderViewModel = {
    userType?: LenderUserType;
    id?: (string) | null;
    finishedOnboarding?: boolean;
    underwritingState?: LenderApplicationUnderwritingState;
    institutionType?: LenderTypeOfInstitution;
    applicationAccessManagement?: LenderApplicationAccessManagement;
    lenderName?: (string) | null;
    assignedSpecialist?: UserViewModel;
    lastProfileUpdate?: number;
    lastCriteriaUpdate?: (number) | null;
    matchResult?: LenderMatchResult;
    loanTypes?: Array<LoanType> | null;
    states?: Array<(string)> | null;
    expressedInterest?: boolean;
    expressedInterestDate?: (number) | null;
    lastOfferDate?: (number) | null;
    acknowledgedDate?: (number) | null;
    matchingDisabled?: boolean;
    createdAt?: (number) | null;
    nonBindingOfferStatus?: LenderOfferStatus;
    bindingOfferStatus?: LenderOfferStatus;
    status?: LenderApplicationStatus;
    offers?: Array<LoanOfferViewModel> | null;
};

export type LoanApplicationContentUpdateRequest = {
    content?: (string) | null;
};

export type LoanApplicationOfferFileStatus = 'NonBinding' | 'Binding' | 'SignedBinding' | 'ClosingDocuments' | 'Covenants' | 'BindingCovenants' | 'Closed' | 'SignedClosing';

export const LoanApplicationOfferFileStatus = {
    NON_BINDING: 'NonBinding',
    BINDING: 'Binding',
    SIGNED_BINDING: 'SignedBinding',
    CLOSING_DOCUMENTS: 'ClosingDocuments',
    COVENANTS: 'Covenants',
    BINDING_COVENANTS: 'BindingCovenants',
    CLOSED: 'Closed',
    SIGNED_CLOSING: 'SignedClosing'
} as const;

export type LoanApplicationOfferStatus = 'NoneSubmitted' | 'SpecialistReview' | 'BorrowerReview' | 'Declined' | 'Accepted';

export const LoanApplicationOfferStatus = {
    NONE_SUBMITTED: 'NoneSubmitted',
    SPECIALIST_REVIEW: 'SpecialistReview',
    BORROWER_REVIEW: 'BorrowerReview',
    DECLINED: 'Declined',
    ACCEPTED: 'Accepted'
} as const;

export type LoanApplicationStatus = 'SpecialistReviewComplete' | 'Screen3' | 'Started' | 'Submitted' | 'SpecialistReview' | 'DiligenceInProgress' | 'CompletedSecondAttestation' | 'AwaitingSubmissionApproval' | 'SubmissionDenied' | 'MoreInformationRequiredBySpecialist' | 'LendersReview' | 'LendersQna' | 'SpecialistOffersReview' | 'OffersSubmitted' | 'OfferAccepted' | 'BtsSubmitted' | 'BtsSignedByBorrower' | 'SignedBtsDenied' | 'SignedBtsApproved' | 'ClosingDocumentsSubmitted' | 'ClosingDocumentsSigned' | 'SignedClosingDocumentsDenied' | 'Closed' | 'Rejected' | 'Cancelled' | 'SpecialistBtsReview' | 'SignedClosingDocumentsApproved' | 'NotFunded' | 'Screen1' | 'LenderBorrowerCallComplete' | 'LenderRequestedInformation' | 'ReadyForBts' | 'SpecialistClosingDocumentsReview' | 'SpecialistFinalClosingDocumentsReview' | 'SpecialistFinalClosingDocumentsApproved' | 'LoanFunded';

export const LoanApplicationStatus = {
    SPECIALIST_REVIEW_COMPLETE: 'SpecialistReviewComplete',
    SCREEN3: 'Screen3',
    STARTED: 'Started',
    SUBMITTED: 'Submitted',
    SPECIALIST_REVIEW: 'SpecialistReview',
    DILIGENCE_IN_PROGRESS: 'DiligenceInProgress',
    COMPLETED_SECOND_ATTESTATION: 'CompletedSecondAttestation',
    AWAITING_SUBMISSION_APPROVAL: 'AwaitingSubmissionApproval',
    SUBMISSION_DENIED: 'SubmissionDenied',
    MORE_INFORMATION_REQUIRED_BY_SPECIALIST: 'MoreInformationRequiredBySpecialist',
    LENDERS_REVIEW: 'LendersReview',
    LENDERS_QNA: 'LendersQna',
    SPECIALIST_OFFERS_REVIEW: 'SpecialistOffersReview',
    OFFERS_SUBMITTED: 'OffersSubmitted',
    OFFER_ACCEPTED: 'OfferAccepted',
    BTS_SUBMITTED: 'BtsSubmitted',
    BTS_SIGNED_BY_BORROWER: 'BtsSignedByBorrower',
    SIGNED_BTS_DENIED: 'SignedBtsDenied',
    SIGNED_BTS_APPROVED: 'SignedBtsApproved',
    CLOSING_DOCUMENTS_SUBMITTED: 'ClosingDocumentsSubmitted',
    CLOSING_DOCUMENTS_SIGNED: 'ClosingDocumentsSigned',
    SIGNED_CLOSING_DOCUMENTS_DENIED: 'SignedClosingDocumentsDenied',
    CLOSED: 'Closed',
    REJECTED: 'Rejected',
    CANCELLED: 'Cancelled',
    SPECIALIST_BTS_REVIEW: 'SpecialistBtsReview',
    SIGNED_CLOSING_DOCUMENTS_APPROVED: 'SignedClosingDocumentsApproved',
    NOT_FUNDED: 'NotFunded',
    SCREEN1: 'Screen1',
    LENDER_BORROWER_CALL_COMPLETE: 'LenderBorrowerCallComplete',
    LENDER_REQUESTED_INFORMATION: 'LenderRequestedInformation',
    READY_FOR_BTS: 'ReadyForBts',
    SPECIALIST_CLOSING_DOCUMENTS_REVIEW: 'SpecialistClosingDocumentsReview',
    SPECIALIST_FINAL_CLOSING_DOCUMENTS_REVIEW: 'SpecialistFinalClosingDocumentsReview',
    SPECIALIST_FINAL_CLOSING_DOCUMENTS_APPROVED: 'SpecialistFinalClosingDocumentsApproved',
    LOAN_FUNDED: 'LoanFunded'
} as const;

export type LoanApplicationSubmitModel = {
    deadline?: number;
};

export type LoanApplicationViewModel = {
    internalBorrowerId?: number;
    fundabilityScore?: number;
    id?: (string) | null;
    previewId?: (string) | null;
    borrowerId?: (string) | null;
    status?: LoanApplicationStatus;
    loanAskAmounts?: Array<LoanAskAmountEntry> | null;
    lenderLoanTypes?: Array<LoanType> | null;
    targetLoanAmount?: number;
    widgetReferral?: (string) | null;
    createdAt?: number;
    submittedAt?: number;
    offerDeadline?: number;
    expectedCloseDate?: (number) | null;
    expectedFundsDate?: (number) | null;
    lastStatusChange?: number;
    loanUse?: LoanUse;
    loanUseDetails?: LoanUseDetails;
    nonBindingOfferStatus?: LoanApplicationOfferStatus;
    bindingOfferStatus?: LoanApplicationOfferStatus;
    personalGuarantee?: boolean;
    hasAccountingReport?: boolean;
    hasTransactionReport?: boolean;
    borrowerProfile?: BorrowerProfile;
    specialist?: UserViewModel;
    lastCxmScore?: number;
    nonBindingFiles?: Array<FileViewModel> | null;
    covenantFiles?: Array<FileViewModel> | null;
    bindingFiles?: Array<FileViewModel> | null;
    closingFiles?: Array<FileViewModel> | null;
    diligenceFiles?: Array<FileViewModel> | null;
    completedLoanFiles?: Array<FileViewModel> | null;
    lenderSummary?: (string) | null;
    companyName?: (string) | null;
    industry?: (string) | null;
    diligenceStatus?: DiligenceStatus;
    applicationPercentComplete?: number;
    profileAdditionalFiles?: Array<AdditionalFileViewModel> | null;
    lenderApplicationStatus?: LenderApplicationStatus;
    loanPreviewContent?: LoanPreviewContent;
    previewGeneratedDate?: (string) | null;
    previewUpdatedDate?: (string) | null;
    previewGeneratedUser?: UserViewModel;
    previewUpdatedUser?: UserViewModel;
    probabilityOfClose?: (number) | null;
    isInUnderwriting?: boolean;
    partners?: Array<PartnerViewModel> | null;
    state?: (string) | null;
    engagedLenders?: Array<LenderViewModel> | null;
    currentLender?: LenderViewModel;
    loanUseSummary?: (string) | null;
    dashboardNote?: (string) | null;
    onHold?: boolean;
};

export type LoanAsk = {
    loanUseDetails?: LoanUseDetails;
    targetLoanAmount?: number;
    loanTypes?: Array<LoanType> | null;
    loanAskAmounts?: Array<LoanAskAmountEntry> | null;
    personalGuarantee?: boolean;
    fundingTimeline?: FundingTimeline;
};

export type LoanAskAmountEntry = {
    loanType?: LoanType;
    amount?: number;
};

export type LoanChartDataResponse = {
    loanApplications?: Array<LoanApplicationViewModel> | null;
    leads?: Array<ReferralViewModel> | null;
};

export type LoanOfferViewModel = {
    id?: (string) | null;
    loanType?: LoanType;
    isBinding?: boolean;
    offerStatus?: OfferStatus;
    applicationId?: number;
    publicApplicationId?: (string) | null;
    lenderId?: (string) | null;
    lenderName?: (string) | null;
    loanAmount?: number;
    rate?: number;
    maturity?: number;
    monthlyPayment?: number;
    totalUpfrontCashFees?: number;
    applicationFees?: number;
    totalCashFees?: number;
    backEndFees?: number;
    originationFees?: number;
    cxmOriginationFees?: number;
    earlyTerminationFees?: number;
    totalPercentageFees?: number;
    covenants?: Array<(number)> | null;
    collaterals?: Array<(number)> | null;
    covenantModels?: Array<CovenantViewModel> | null;
    collateralModels?: Array<CovenantViewModel> | null;
    personalGuarantee?: boolean;
    targetCloseDate?: number;
    amortization?: number;
    files?: Array<FileViewModel> | null;
    createdAt?: number;
    status?: OfferStatus;
};

export type LoanPreviewContent = {
    anonymizedTitle?: (string) | null;
    previewHeadline?: (string) | null;
    sections?: Array<LoanPreviewSection> | null;
};

export type LoanPreviewSection = {
    title?: (string) | null;
    content?: (string) | null;
};

export type LoanType = 'Abl' | 'ArFactoring' | 'Sba' | 'Equipment' | 'Sbic' | 'CashFlow' | 'JuniorMezz' | 'VentureRev' | 'Cre' | 'RealEstate' | 'Inventory' | 'Mna' | 'PurchaseOrder' | 'SbaRealEstate' | 'RevFinancing' | 'AllLoans';

export const LoanType = {
    ABL: 'Abl',
    AR_FACTORING: 'ArFactoring',
    SBA: 'Sba',
    EQUIPMENT: 'Equipment',
    SBIC: 'Sbic',
    CASH_FLOW: 'CashFlow',
    JUNIOR_MEZZ: 'JuniorMezz',
    VENTURE_REV: 'VentureRev',
    CRE: 'Cre',
    REAL_ESTATE: 'RealEstate',
    INVENTORY: 'Inventory',
    MNA: 'Mna',
    PURCHASE_ORDER: 'PurchaseOrder',
    SBA_REAL_ESTATE: 'SbaRealEstate',
    REV_FINANCING: 'RevFinancing',
    ALL_LOANS: 'AllLoans'
} as const;

export type LoanTypeLenderCriteria = {
    loanType?: LoanType;
    criteria?: LenderCriteria;
};

export type LoanUse = 'Unknown' | 'Acquisition' | 'Growth_Capital' | 'GeneralWorking_Capital' | 'InventoryEquipment_Or_Other_Asset_Purchase' | 'Refinance' | 'Shareholder_Liquidity' | 'Inventory' | 'Equipment' | 'RealEstate' | 'Factoring_Or_Purchase_Order';

export const LoanUse = {
    UNKNOWN: 'Unknown',
    ACQUISITION: 'Acquisition',
    GROWTH_CAPITAL: 'Growth_Capital',
    GENERAL_WORKING_CAPITAL: 'GeneralWorking_Capital',
    INVENTORY_EQUIPMENT_OR_OTHER_ASSET_PURCHASE: 'InventoryEquipment_Or_Other_Asset_Purchase',
    REFINANCE: 'Refinance',
    SHAREHOLDER_LIQUIDITY: 'Shareholder_Liquidity',
    INVENTORY: 'Inventory',
    EQUIPMENT: 'Equipment',
    REAL_ESTATE: 'RealEstate',
    FACTORING_OR_PURCHASE_ORDER: 'Factoring_Or_Purchase_Order'
} as const;

export type LoanUseDetails = {
    loanUse?: {
        Unknown?: number;
        Acquisition?: number;
        Growth_Capital?: number;
        GeneralWorking_Capital?: number;
        InventoryEquipment_Or_Other_Asset_Purchase?: number;
        Refinance?: number;
        Shareholder_Liquidity?: number;
        Inventory?: number;
        Equipment?: number;
        RealEstate?: number;
        Factoring_Or_Purchase_Order?: number;
    } | null;
    refinanceUse?: {
        RealEstate?: number;
        Equipment?: number;
        Inventory?: number;
        Other?: number;
    } | null;
    purchaseUse?: {
        RealEstate?: number;
        Equipment?: number;
        Inventory?: number;
        Other?: number;
    } | null;
};

export type Location = {
    address?: (string) | null;
    city?: (string) | null;
    region?: (string) | null;
    postal_code?: (string) | null;
    country?: (string) | null;
    lat?: (number) | null;
    lon?: (number) | null;
    store_number?: (string) | null;
};

export type MessageViewModel = {
    hasEngagedLender?: boolean;
    messageSendTime?: number;
    content?: (string) | null;
    id?: number;
    fromUser?: UserViewModel;
    attachments?: Array<AttachmentViewModel> | null;
    attachmentIds?: Array<(string)> | null;
    messageRole?: PortalType;
};

export type MetricAssessment = {
    name?: (string) | null;
    value?: number;
    quality?: MetricQuality;
    fairValue?: number;
};

export type MetricQuality = 'Bad' | 'Poor' | 'Fair' | 'Good' | 'Great' | 'Excellent';

export const MetricQuality = {
    BAD: 'Bad',
    POOR: 'Poor',
    FAIR: 'Fair',
    GOOD: 'Good',
    GREAT: 'Great',
    EXCELLENT: 'Excellent'
} as const;

export type MonthCashBasedProfitLossReport = {
    year?: number;
    month?: number;
    income?: number;
    loanPayments?: number;
    other?: number;
    bankFees?: number;
    foodAndDrink?: number;
    generalMerchandise?: number;
    generalServices?: number;
    transportation?: number;
    travel?: number;
    rentAndUtilities?: number;
};

export type NoteViewmodel = {
    id?: (string) | null;
    user?: UserViewModel;
    note?: (string) | null;
    portal?: PortalType;
    createdAt?: number;
    updatedAt?: number;
};

export type NotesData = {
    notes?: (string) | null;
};

export type NotificationLevel = 'Created' | 'Seen' | 'Suppressed';

export const NotificationLevel = {
    CREATED: 'Created',
    SEEN: 'Seen',
    SUPPRESSED: 'Suppressed'
} as const;

export type NotificationType = 'OfferNotification' | 'BtsNotification' | 'MessageNotification' | 'ActionRequiredNotification';

export const NotificationType = {
    OFFER_NOTIFICATION: 'OfferNotification',
    BTS_NOTIFICATION: 'BtsNotification',
    MESSAGE_NOTIFICATION: 'MessageNotification',
    ACTION_REQUIRED_NOTIFICATION: 'ActionRequiredNotification'
} as const;

export type NotificationViewModel = {
    loanApplicationId?: number;
    notificationId?: number;
    notificationMessage?: (string) | null;
    type?: NotificationType;
    level?: NotificationLevel;
    createdDateMillis?: number;
};

export type OfferList = {
    offerIds?: Array<(string)> | null;
};

export type OfferStatus = 'SubmittedByLender' | 'SubmittedToLenderForImprovement' | 'ApprovedBySpecialist' | 'AcceptedByBorrower' | 'RejectedByBorrower' | 'Closed';

export const OfferStatus = {
    SUBMITTED_BY_LENDER: 'SubmittedByLender',
    SUBMITTED_TO_LENDER_FOR_IMPROVEMENT: 'SubmittedToLenderForImprovement',
    APPROVED_BY_SPECIALIST: 'ApprovedBySpecialist',
    ACCEPTED_BY_BORROWER: 'AcceptedByBorrower',
    REJECTED_BY_BORROWER: 'RejectedByBorrower',
    CLOSED: 'Closed'
} as const;

export type Officer = {
    firstName?: (string) | null;
    lastName?: (string) | null;
    title?: (string) | null;
    email?: (string) | null;
    phoneNumber?: (string) | null;
    percentageShare?: (number) | null;
    socialSecurityNumber?: (string) | null;
    driversLicenseFile?: (string) | null;
    authorizedSignatory?: (boolean) | null;
};

export type PartnerGroupViewModel = {
    id?: (string) | null;
    name?: (string) | null;
    createdAt?: (string) | null;
};

export type PartnerViewModel = {
    name?: (string) | null;
    id?: (string) | null;
    groupId?: (string) | null;
    fee?: number;
    referralTag?: (string) | null;
    contactName?: (string) | null;
    contactAddress?: (string) | null;
    contactEmail?: (string) | null;
    contactPhoneNumber?: (string) | null;
    startDate?: (string) | null;
    endDate?: (string) | null;
};

export type PaymentMeta = {
    reference_number?: (string) | null;
    ppd_id?: (string) | null;
    payee?: (string) | null;
    by_order_of?: (string) | null;
    payer?: (string) | null;
    payment_method?: (string) | null;
    payment_processor?: (string) | null;
    reason?: (string) | null;
};

export type PersonalFinanceCategory = {
    primary?: (string) | null;
    detailed?: (string) | null;
    confidence_level?: (string) | null;
};

export type PortalType = 'Management' | 'Lender' | 'Borrower';

export const PortalType = {
    MANAGEMENT: 'Management',
    LENDER: 'Lender',
    BORROWER: 'Borrower'
} as const;

export type ProfileFileType = 'Additional' | 'OrgChart' | 'BusinessPlan' | 'CustomerContract' | 'TaxReturns' | 'LastYearBankStatements' | 'HistoricalPLFiles' | 'ForecastPLFiles' | 'MostRecentBalanceSheet' | 'PreviousYearsBalanceSheet' | 'AccountsReceivableSchedule' | 'InventorySupporting' | 'InventoryBreakdown' | 'AccountsPayableSchedule' | 'EquipmentBreakdown' | 'RealEstateBreakdown' | 'RealEstateAppraisal' | 'AdditionalDebt';

export const ProfileFileType = {
    ADDITIONAL: 'Additional',
    ORG_CHART: 'OrgChart',
    BUSINESS_PLAN: 'BusinessPlan',
    CUSTOMER_CONTRACT: 'CustomerContract',
    TAX_RETURNS: 'TaxReturns',
    LAST_YEAR_BANK_STATEMENTS: 'LastYearBankStatements',
    HISTORICAL_PLFILES: 'HistoricalPLFiles',
    FORECAST_PLFILES: 'ForecastPLFiles',
    MOST_RECENT_BALANCE_SHEET: 'MostRecentBalanceSheet',
    PREVIOUS_YEARS_BALANCE_SHEET: 'PreviousYearsBalanceSheet',
    ACCOUNTS_RECEIVABLE_SCHEDULE: 'AccountsReceivableSchedule',
    INVENTORY_SUPPORTING: 'InventorySupporting',
    INVENTORY_BREAKDOWN: 'InventoryBreakdown',
    ACCOUNTS_PAYABLE_SCHEDULE: 'AccountsPayableSchedule',
    EQUIPMENT_BREAKDOWN: 'EquipmentBreakdown',
    REAL_ESTATE_BREAKDOWN: 'RealEstateBreakdown',
    REAL_ESTATE_APPRAISAL: 'RealEstateAppraisal',
    ADDITIONAL_DEBT: 'AdditionalDebt'
} as const;

export type ProfitLossMetrics = {
    monthlyRecurringRevenue?: (number) | null;
    annualChurn?: (number) | null;
    previousYearsFiles?: Array<(string)> | null;
    ttmAverageCash?: (number) | null;
    yearlyDebtService?: (number) | null;
    previousYearsMetrics?: Array<YearProfitLossMetrics> | null;
    ttmMetrics?: YearProfitLossMetrics;
    ytdMetrics?: YearProfitLossMetrics;
    currentAndNextYearProjectionFiles?: Array<(string)> | null;
    forecastedYearsMetrics?: Array<YearProfitLossMetrics> | null;
    fiscalYearEnd?: (number) | null;
};

export type ProfitLossReport = {
    startDate?: string;
    endDate?: string;
    income?: ProfitLossReportEntry;
    costOfSales?: ProfitLossReportEntry;
    operatingExpenses?: ProfitLossReportEntry;
    nonOperatingExpenses?: ProfitLossReportEntry;
    otherIncome?: ProfitLossReportEntry;
};

export type ProfitLossReportEntry = {
    name?: (string) | null;
    totals?: Array<(number)> | null;
    subItems?: Array<ProfitLossReportEntry> | null;
};

export type RateReference = 'Absolute' | 'LIBOR' | 'SOFR' | 'Prime';

export const RateReference = {
    ABSOLUTE: 'Absolute',
    LIBOR: 'LIBOR',
    SOFR: 'SOFR',
    PRIME: 'Prime'
} as const;

export type ReferralData = {
    companyName?: (string) | null;
    contactName?: (string) | null;
    contactEmail?: (string) | null;
    contactPhone?: (string) | null;
    loanAsk?: (number) | null;
    loanType?: LoanType;
    referralFiles?: Array<(string)> | null;
};

export type ReferralState = 'Active' | 'OnHold' | 'Cancelled';

export const ReferralState = {
    ACTIVE: 'Active',
    ON_HOLD: 'OnHold',
    CANCELLED: 'Cancelled'
} as const;

export type ReferralViewModel = {
    data?: ReferralData;
    createdAt?: number;
    lenderName?: (string) | null;
    companyName?: (string) | null;
    dashboardNote?: (string) | null;
    loanAppId?: (string) | null;
    id?: number;
    createdBy?: UserViewModel;
    state?: ReferralState;
};

export type ReportEntry = {
    name?: (string) | null;
    total?: number;
    subItems?: Array<ReportEntry> | null;
};

export type ReportType = 'BalanceSheet' | 'AccountsReceivable' | 'AccountsPayable';

export const ReportType = {
    BALANCE_SHEET: 'BalanceSheet',
    ACCOUNTS_RECEIVABLE: 'AccountsReceivable',
    ACCOUNTS_PAYABLE: 'AccountsPayable'
} as const;

export type RevenueMix = 'Unknown' | 'B2B' | 'B2C' | 'ProjectBasedContractual' | 'Recurring';

export const RevenueMix = {
    UNKNOWN: 'Unknown',
    B2B: 'B2B',
    B2C: 'B2C',
    PROJECT_BASED_CONTRACTUAL: 'ProjectBasedContractual',
    RECURRING: 'Recurring'
} as const;

export type RiskAssessment = 'VeryLow' | 'Low' | 'Medium' | 'High' | 'None';

export const RiskAssessment = {
    VERY_LOW: 'VeryLow',
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    NONE: 'None'
} as const;

export type RiskAssessmentSnapshot = {
    financial?: RiskAssessment;
    operations?: RiskAssessment;
    supply?: RiskAssessment;
    cyber?: RiskAssessment;
    product?: RiskAssessment;
    sales?: RiskAssessment;
};

export type RsgAnalysis = {
    ninetyDayRoadmap?: Array<RsgRoadmapTask> | null;
    sixMonthRoadmap?: Array<RsgRoadmapTask> | null;
    yearRoadmap?: Array<RsgRoadmapTask> | null;
    overallHealthScore?: number;
    financialHealthScore?: number;
    operationalHealthScore?: number;
    cyberScore?: number;
    industryRiskAssessment?: RiskAssessment;
    nextQuarterAssessment?: RiskAssessmentSnapshot;
    currentQuarterAssessment?: RiskAssessmentSnapshot;
    lastQuarterAssessment?: RiskAssessmentSnapshot;
    sixMonthsAgoAssessment?: RiskAssessmentSnapshot;
    oneYearAgoAssessment?: RiskAssessmentSnapshot;
    withinSixMonthsPotential?: RsgRevenuePotential;
    sixToTwelveMonthsPotential?: RsgRevenuePotential;
    twelveToEighteenMonthsPotential?: RsgRevenuePotential;
    totalPotential?: RsgRevenuePotential;
};

export type RsgDashboardViewmodel = {
    rsgAnalysis?: RsgAnalysis;
};

export type RsgRevenuePotential = {
    min?: number;
    max?: number;
};

export type RsgRoadmapTask = {
    minPotentialRevenue?: number;
    maxPotentialRevenue?: number;
    startDate?: string;
    endDate?: string;
    subTasks?: Array<(string)> | null;
    title?: (string) | null;
};

export type SendMessageModel = {
    [key: string]: unknown;
};

export type SpecialistLenderProfileModel = {
    id?: (string) | null;
    region?: LenderRegionViewModel;
    altContactName?: (string) | null;
    altContactNumber?: (string) | null;
    lenderName?: (string) | null;
    businessOverview?: (string) | null;
    primaryContact?: UserViewModel;
    primaryContactId?: (number) | null;
    loanTypes?: Array<LoanType> | null;
    address?: Address;
    numberOfLocations?: number;
    typeOfInstitution?: LenderTypeOfInstitution;
    emailAddress?: (string) | null;
    loanAssetsUnderMgmt?: number;
    totalBalanceSheet?: number;
    assignedSpecialist?: (number) | null;
};

export type StringStringTuple = {
    item1?: (string) | null;
    item2?: (string) | null;
};

export type SubIndustry = 'CropProduction' | 'AnimalProductionAndAquaculture' | 'ForestryAndLogging' | 'FishingHuntingAndTrapping' | 'SupportActivitiesForAgricultureAndForestry' | 'OilAndGasExtraction' | 'MiningExceptOilAndGas' | 'SupportActivitiesForMining' | 'Utilities' | 'ConstructionOfBuildings' | 'HeavyAndCivilEngineeringConstruction' | 'SpecialtyTradeContractors' | 'FoodManufacturing' | 'BeverageAndTobaccoProductManufacturing' | 'TextileMills' | 'TextileProductMills' | 'ApparelManufacturing' | 'LeatherAndAlliedProductManufacturing' | 'WoodProductManufacturing' | 'PaperManufacturing' | 'PrintingAndRelatedSupportActivities' | 'PetroleumAndCoalProductsManufacturing' | 'ChemicalManufacturing' | 'PlasticsAndRubberProductsManufacturing' | 'NonmetallicMineralProductManufacturing' | 'PrimaryMetalManufacturing' | 'FabricatedMetalProductManufacturing' | 'MachineryManufacturing' | 'ComputerAndElectronicProductManufacturing' | 'ElectricalEquipmentApplianceAndComponentManufacturing' | 'TransportationEquipmentManufacturing' | 'FurnitureAndRelatedProductManufacturing' | 'MiscellaneousManufacturing' | 'MerchantWholesalersDurableGoods' | 'MerchantWholesalersNondurableGoods' | 'WholesaleElectronicMarketsAndAgentsAndBrokers' | 'MotorVehicleAndPartsDealers' | 'FurnitureAndHomeFurnishingsStores' | 'ElectronicsAndApplianceStores' | 'BuildingMaterialAndGardenEquipmentAndSuppliesDealers' | 'FoodAndBeverageStores' | 'HealthAndPersonalCareStores' | 'GasolineStations' | 'ClothingAndClothingAccessoriesStores' | 'SportingGoodsHobbyMusicalInstrumentAndBookStores' | 'GeneralMerchandiseStores' | 'MiscellaneousStoreRetailers' | 'NonstoreRetailers' | 'AirTransportation' | 'RailTransportation' | 'WaterTransportation' | 'TruckTransportation' | 'TransitAndGroundPassengerTransportation' | 'PipelineTransportation' | 'ScenicAndSightseeingTransportation' | 'SupportActivitiesForTransportation' | 'PostalService' | 'CouriersAndMessengers' | 'WarehousingAndStorage' | 'PublishingIndustriesExceptInternet' | 'MotionPictureAndSoundRecordingIndustries' | 'BroadcastingExceptInternet' | 'Telecommunications' | 'DataProcessingHostingAndRelatedServices' | 'OtherInformationServices' | 'MonetaryAuthoritiesCentralBank' | 'CreditIntermediationAndRelatedActivities' | 'SecuritiesCommodityContractsAndOtherFinancialInvestmentsAndRelatedActivities' | 'InsuranceCarriersAndRelatedActivities' | 'FundsTrustsAndOtherFinancialVehicles' | 'RealEstate' | 'RentalAndLeasingServices' | 'LessorsOfNonfinancialIntangibleAssetsExceptCopyrightedWorks' | 'ProfessionalScientificAndTechnicalServices' | 'ManagementOfCompaniesAndEnterprises' | 'AdministrativeAndSupportServices' | 'WasteManagementAndRemediationServices' | 'EducationalServices' | 'AmbulatoryHealthCareServices' | 'Hospitals' | 'NursingAndResidentialCareFacilities' | 'SocialAssistance' | 'PerformingArtsSpectatorSportsAndRelatedIndustries' | 'MuseumsHistoricalSitesAndSimilarInstitutions' | 'AmusementGamblingAndRecreationIndustries' | 'Accommodation' | 'FoodServicesAndDrinkingPlaces' | 'RepairAndMaintenance' | 'PersonalAndLaundryServices' | 'ReligiousGrantmakingCivicProfessionalAndSimilarOrganizations' | 'PrivateHouseholds' | 'ExecutiveLegislativeAndOtherGeneralGovernmentSupport' | 'JusticePublicOrderAndSafetyActivities' | 'AdministrationOfHumanResourcePrograms' | 'AdministrationOfEnvironmentalQualityPrograms' | 'AdministrationOfHousingProgramsUrbanPlanningAndCommunityDevelopment' | 'AdministrationOfEconomicPrograms' | 'SpaceResearchAndTechnology' | 'NationalSecurityAndInternationalAffairs' | 'ComputerSystemsDesignAndRelatedServices';

export const SubIndustry = {
    CROP_PRODUCTION: 'CropProduction',
    ANIMAL_PRODUCTION_AND_AQUACULTURE: 'AnimalProductionAndAquaculture',
    FORESTRY_AND_LOGGING: 'ForestryAndLogging',
    FISHING_HUNTING_AND_TRAPPING: 'FishingHuntingAndTrapping',
    SUPPORT_ACTIVITIES_FOR_AGRICULTURE_AND_FORESTRY: 'SupportActivitiesForAgricultureAndForestry',
    OIL_AND_GAS_EXTRACTION: 'OilAndGasExtraction',
    MINING_EXCEPT_OIL_AND_GAS: 'MiningExceptOilAndGas',
    SUPPORT_ACTIVITIES_FOR_MINING: 'SupportActivitiesForMining',
    UTILITIES: 'Utilities',
    CONSTRUCTION_OF_BUILDINGS: 'ConstructionOfBuildings',
    HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION: 'HeavyAndCivilEngineeringConstruction',
    SPECIALTY_TRADE_CONTRACTORS: 'SpecialtyTradeContractors',
    FOOD_MANUFACTURING: 'FoodManufacturing',
    BEVERAGE_AND_TOBACCO_PRODUCT_MANUFACTURING: 'BeverageAndTobaccoProductManufacturing',
    TEXTILE_MILLS: 'TextileMills',
    TEXTILE_PRODUCT_MILLS: 'TextileProductMills',
    APPAREL_MANUFACTURING: 'ApparelManufacturing',
    LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING: 'LeatherAndAlliedProductManufacturing',
    WOOD_PRODUCT_MANUFACTURING: 'WoodProductManufacturing',
    PAPER_MANUFACTURING: 'PaperManufacturing',
    PRINTING_AND_RELATED_SUPPORT_ACTIVITIES: 'PrintingAndRelatedSupportActivities',
    PETROLEUM_AND_COAL_PRODUCTS_MANUFACTURING: 'PetroleumAndCoalProductsManufacturing',
    CHEMICAL_MANUFACTURING: 'ChemicalManufacturing',
    PLASTICS_AND_RUBBER_PRODUCTS_MANUFACTURING: 'PlasticsAndRubberProductsManufacturing',
    NONMETALLIC_MINERAL_PRODUCT_MANUFACTURING: 'NonmetallicMineralProductManufacturing',
    PRIMARY_METAL_MANUFACTURING: 'PrimaryMetalManufacturing',
    FABRICATED_METAL_PRODUCT_MANUFACTURING: 'FabricatedMetalProductManufacturing',
    MACHINERY_MANUFACTURING: 'MachineryManufacturing',
    COMPUTER_AND_ELECTRONIC_PRODUCT_MANUFACTURING: 'ComputerAndElectronicProductManufacturing',
    ELECTRICAL_EQUIPMENT_APPLIANCE_AND_COMPONENT_MANUFACTURING: 'ElectricalEquipmentApplianceAndComponentManufacturing',
    TRANSPORTATION_EQUIPMENT_MANUFACTURING: 'TransportationEquipmentManufacturing',
    FURNITURE_AND_RELATED_PRODUCT_MANUFACTURING: 'FurnitureAndRelatedProductManufacturing',
    MISCELLANEOUS_MANUFACTURING: 'MiscellaneousManufacturing',
    MERCHANT_WHOLESALERS_DURABLE_GOODS: 'MerchantWholesalersDurableGoods',
    MERCHANT_WHOLESALERS_NONDURABLE_GOODS: 'MerchantWholesalersNondurableGoods',
    WHOLESALE_ELECTRONIC_MARKETS_AND_AGENTS_AND_BROKERS: 'WholesaleElectronicMarketsAndAgentsAndBrokers',
    MOTOR_VEHICLE_AND_PARTS_DEALERS: 'MotorVehicleAndPartsDealers',
    FURNITURE_AND_HOME_FURNISHINGS_STORES: 'FurnitureAndHomeFurnishingsStores',
    ELECTRONICS_AND_APPLIANCE_STORES: 'ElectronicsAndApplianceStores',
    BUILDING_MATERIAL_AND_GARDEN_EQUIPMENT_AND_SUPPLIES_DEALERS: 'BuildingMaterialAndGardenEquipmentAndSuppliesDealers',
    FOOD_AND_BEVERAGE_STORES: 'FoodAndBeverageStores',
    HEALTH_AND_PERSONAL_CARE_STORES: 'HealthAndPersonalCareStores',
    GASOLINE_STATIONS: 'GasolineStations',
    CLOTHING_AND_CLOTHING_ACCESSORIES_STORES: 'ClothingAndClothingAccessoriesStores',
    SPORTING_GOODS_HOBBY_MUSICAL_INSTRUMENT_AND_BOOK_STORES: 'SportingGoodsHobbyMusicalInstrumentAndBookStores',
    GENERAL_MERCHANDISE_STORES: 'GeneralMerchandiseStores',
    MISCELLANEOUS_STORE_RETAILERS: 'MiscellaneousStoreRetailers',
    NONSTORE_RETAILERS: 'NonstoreRetailers',
    AIR_TRANSPORTATION: 'AirTransportation',
    RAIL_TRANSPORTATION: 'RailTransportation',
    WATER_TRANSPORTATION: 'WaterTransportation',
    TRUCK_TRANSPORTATION: 'TruckTransportation',
    TRANSIT_AND_GROUND_PASSENGER_TRANSPORTATION: 'TransitAndGroundPassengerTransportation',
    PIPELINE_TRANSPORTATION: 'PipelineTransportation',
    SCENIC_AND_SIGHTSEEING_TRANSPORTATION: 'ScenicAndSightseeingTransportation',
    SUPPORT_ACTIVITIES_FOR_TRANSPORTATION: 'SupportActivitiesForTransportation',
    POSTAL_SERVICE: 'PostalService',
    COURIERS_AND_MESSENGERS: 'CouriersAndMessengers',
    WAREHOUSING_AND_STORAGE: 'WarehousingAndStorage',
    PUBLISHING_INDUSTRIES_EXCEPT_INTERNET: 'PublishingIndustriesExceptInternet',
    MOTION_PICTURE_AND_SOUND_RECORDING_INDUSTRIES: 'MotionPictureAndSoundRecordingIndustries',
    BROADCASTING_EXCEPT_INTERNET: 'BroadcastingExceptInternet',
    TELECOMMUNICATIONS: 'Telecommunications',
    DATA_PROCESSING_HOSTING_AND_RELATED_SERVICES: 'DataProcessingHostingAndRelatedServices',
    OTHER_INFORMATION_SERVICES: 'OtherInformationServices',
    MONETARY_AUTHORITIES_CENTRAL_BANK: 'MonetaryAuthoritiesCentralBank',
    CREDIT_INTERMEDIATION_AND_RELATED_ACTIVITIES: 'CreditIntermediationAndRelatedActivities',
    SECURITIES_COMMODITY_CONTRACTS_AND_OTHER_FINANCIAL_INVESTMENTS_AND_RELATED_ACTIVITIES: 'SecuritiesCommodityContractsAndOtherFinancialInvestmentsAndRelatedActivities',
    INSURANCE_CARRIERS_AND_RELATED_ACTIVITIES: 'InsuranceCarriersAndRelatedActivities',
    FUNDS_TRUSTS_AND_OTHER_FINANCIAL_VEHICLES: 'FundsTrustsAndOtherFinancialVehicles',
    REAL_ESTATE: 'RealEstate',
    RENTAL_AND_LEASING_SERVICES: 'RentalAndLeasingServices',
    LESSORS_OF_NONFINANCIAL_INTANGIBLE_ASSETS_EXCEPT_COPYRIGHTED_WORKS: 'LessorsOfNonfinancialIntangibleAssetsExceptCopyrightedWorks',
    PROFESSIONAL_SCIENTIFIC_AND_TECHNICAL_SERVICES: 'ProfessionalScientificAndTechnicalServices',
    MANAGEMENT_OF_COMPANIES_AND_ENTERPRISES: 'ManagementOfCompaniesAndEnterprises',
    ADMINISTRATIVE_AND_SUPPORT_SERVICES: 'AdministrativeAndSupportServices',
    WASTE_MANAGEMENT_AND_REMEDIATION_SERVICES: 'WasteManagementAndRemediationServices',
    EDUCATIONAL_SERVICES: 'EducationalServices',
    AMBULATORY_HEALTH_CARE_SERVICES: 'AmbulatoryHealthCareServices',
    HOSPITALS: 'Hospitals',
    NURSING_AND_RESIDENTIAL_CARE_FACILITIES: 'NursingAndResidentialCareFacilities',
    SOCIAL_ASSISTANCE: 'SocialAssistance',
    PERFORMING_ARTS_SPECTATOR_SPORTS_AND_RELATED_INDUSTRIES: 'PerformingArtsSpectatorSportsAndRelatedIndustries',
    MUSEUMS_HISTORICAL_SITES_AND_SIMILAR_INSTITUTIONS: 'MuseumsHistoricalSitesAndSimilarInstitutions',
    AMUSEMENT_GAMBLING_AND_RECREATION_INDUSTRIES: 'AmusementGamblingAndRecreationIndustries',
    ACCOMMODATION: 'Accommodation',
    FOOD_SERVICES_AND_DRINKING_PLACES: 'FoodServicesAndDrinkingPlaces',
    REPAIR_AND_MAINTENANCE: 'RepairAndMaintenance',
    PERSONAL_AND_LAUNDRY_SERVICES: 'PersonalAndLaundryServices',
    RELIGIOUS_GRANTMAKING_CIVIC_PROFESSIONAL_AND_SIMILAR_ORGANIZATIONS: 'ReligiousGrantmakingCivicProfessionalAndSimilarOrganizations',
    PRIVATE_HOUSEHOLDS: 'PrivateHouseholds',
    EXECUTIVE_LEGISLATIVE_AND_OTHER_GENERAL_GOVERNMENT_SUPPORT: 'ExecutiveLegislativeAndOtherGeneralGovernmentSupport',
    JUSTICE_PUBLIC_ORDER_AND_SAFETY_ACTIVITIES: 'JusticePublicOrderAndSafetyActivities',
    ADMINISTRATION_OF_HUMAN_RESOURCE_PROGRAMS: 'AdministrationOfHumanResourcePrograms',
    ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_PROGRAMS: 'AdministrationOfEnvironmentalQualityPrograms',
    ADMINISTRATION_OF_HOUSING_PROGRAMS_URBAN_PLANNING_AND_COMMUNITY_DEVELOPMENT: 'AdministrationOfHousingProgramsUrbanPlanningAndCommunityDevelopment',
    ADMINISTRATION_OF_ECONOMIC_PROGRAMS: 'AdministrationOfEconomicPrograms',
    SPACE_RESEARCH_AND_TECHNOLOGY: 'SpaceResearchAndTechnology',
    NATIONAL_SECURITY_AND_INTERNATIONAL_AFFAIRS: 'NationalSecurityAndInternationalAffairs',
    COMPUTER_SYSTEMS_DESIGN_AND_RELATED_SERVICES: 'ComputerSystemsDesignAndRelatedServices'
} as const;

export type TaxInformation = {
    fullTimeCFO?: (boolean) | null;
    outsideAccountant?: (boolean) | null;
    taxReturnFiles?: Array<(string)> | null;
    lastYearBankStatementFiles?: Array<(string)> | null;
};

export type TemplateAssessment = 'Poor' | 'Fair' | 'Good';

export const TemplateAssessment = {
    POOR: 'Poor',
    FAIR: 'Fair',
    GOOD: 'Good'
} as const;

export type TemplateType = 'String' | 'Number' | 'Currency' | 'Phone' | 'Boolean';

export const TemplateType = {
    STRING: 'String',
    NUMBER: 'Number',
    CURRENCY: 'Currency',
    PHONE: 'Phone',
    BOOLEAN: 'Boolean'
} as const;

export type Transaction = {
    account_id?: (string) | null;
    amount?: (number) | null;
    iso_currency_code?: (string) | null;
    unofficial_currency_code?: (string) | null;
    category?: Array<(string)> | null;
    category_id?: (string) | null;
    check_number?: (string) | null;
    date?: (string) | null;
    location?: Location;
    name?: (string) | null;
    merchant_name?: (string) | null;
    original_description?: (string) | null;
    payment_meta?: PaymentMeta;
    pending?: (boolean) | null;
    pending_transaction_id?: (string) | null;
    account_owner?: (string) | null;
    transaction_id?: (string) | null;
    transaction_type?: TransactionTransactionTypeEnum;
    logo_url?: (string) | null;
    website?: (string) | null;
    authorized_date?: (string) | null;
    authorized_datetime?: (string) | null;
    datetime?: (string) | null;
    payment_channel?: TransactionPaymentChannelEnum;
    personal_finance_category?: PersonalFinanceCategory;
    transaction_code?: TransactionCode;
    personal_finance_category_icon_url?: (string) | null;
    counterparties?: Array<Counterparty> | null;
    merchant_entity_id?: (string) | null;
};

export type TransactionCode = 'Adjustment' | 'Atm' | 'BankCharge' | 'BillPayment' | 'Cash' | 'Cashback' | 'Cheque' | 'DirectDebit' | 'Interest' | 'Purchase' | 'StandingOrder' | 'Transfer' | 'Undefined';

export const TransactionCode = {
    ADJUSTMENT: 'Adjustment',
    ATM: 'Atm',
    BANK_CHARGE: 'BankCharge',
    BILL_PAYMENT: 'BillPayment',
    CASH: 'Cash',
    CASHBACK: 'Cashback',
    CHEQUE: 'Cheque',
    DIRECT_DEBIT: 'DirectDebit',
    INTEREST: 'Interest',
    PURCHASE: 'Purchase',
    STANDING_ORDER: 'StandingOrder',
    TRANSFER: 'Transfer',
    UNDEFINED: 'Undefined'
} as const;

export type TransactionPaymentChannelEnum = 'Online' | 'InStore' | 'Other' | 'Undefined';

export const TransactionPaymentChannelEnum = {
    ONLINE: 'Online',
    IN_STORE: 'InStore',
    OTHER: 'Other',
    UNDEFINED: 'Undefined'
} as const;

export type TransactionTransactionTypeEnum = 'Digital' | 'Place' | 'Special' | 'Unresolved' | 'Undefined';

export const TransactionTransactionTypeEnum = {
    DIGITAL: 'Digital',
    PLACE: 'Place',
    SPECIAL: 'Special',
    UNRESOLVED: 'Unresolved',
    UNDEFINED: 'Undefined'
} as const;

export type UpdateCompanyNameRequest = {
    name?: (string) | null;
};

export type UpdateLoanAccessRequest = {
    lenderUserIds?: Array<(number)> | null;
};

export type UserViewModel = {
    lenderCount?: number;
    borrowerCount?: number;
    isSpecialist?: boolean;
    isSupervisor?: boolean;
    isAdmin?: boolean;
    isLender?: boolean;
    isBorrower?: boolean;
    id?: number;
    lastLoginTime?: number;
    createdDate?: (number) | null;
    auth0Id?: (string) | null;
    firstname?: (string) | null;
    lastname?: (string) | null;
    phoneNumber?: (string) | null;
    email?: (string) | null;
    activeLenderName?: (string) | null;
    activeLenderId?: (string) | null;
};

export type ValidationResponse = {
    valid?: boolean;
    result?: number;
};

export type YearProfitLossMetrics = {
    revenues?: (number) | null;
    costOfSales?: (number) | null;
    grossProfit?: (number) | null;
    sga?: (number) | null;
    ebitda?: (number) | null;
    interestExpense?: (number) | null;
    totalOtherIncome?: (number) | null;
    totalOtherExpenses?: (number) | null;
    netIncome?: (number) | null;
    year?: (number) | null;
};

export type GetApiBorrowersPlaidLinkResponse = (string);

export type GetApiBorrowersPlaidLinkError = unknown;

export type PostApiBorrowersStartQuickbooksLinkResponse = (string);

export type PostApiBorrowersStartQuickbooksLinkError = unknown;

export type PostApiBorrowersRunQuickbooksReportResponse = (unknown);

export type PostApiBorrowersRunQuickbooksReportError = unknown;

export type GetApiBorrowersAccountingReportSheetData = {
    query?: {
        borrowerId?: string;
        portalType?: PortalType;
        reportType?: ReportType;
    };
};

export type GetApiBorrowersAccountingReportSheetResponse = (unknown);

export type GetApiBorrowersAccountingReportSheetError = unknown;

export type GetApiBorrowersAccountingProfitLossReportSheetData = {
    query?: {
        borrowerId?: string;
        portalType?: PortalType;
    };
};

export type GetApiBorrowersAccountingProfitLossReportSheetResponse = (unknown);

export type GetApiBorrowersAccountingProfitLossReportSheetError = unknown;

export type PostApiBorrowersSyncAccountingBalanceSheetMetricsResponse = (AccountingBalanceSheetMetrics);

export type PostApiBorrowersSyncAccountingBalanceSheetMetricsError = unknown;

export type PostApiBorrowersSyncAccountingProfitLossMetricsResponse = (AccountingProfitLossMetricsReport);

export type PostApiBorrowersSyncAccountingProfitLossMetricsError = unknown;

export type GetApiBorrowersAccountingReportData = {
    query?: {
        borrowerId?: string;
        portalType?: PortalType;
    };
};

export type GetApiBorrowersAccountingReportResponse = (AccountingReportResult);

export type GetApiBorrowersAccountingReportError = unknown;

export type PostApiBorrowersDisconnectQuickbooksResponse = (unknown);

export type PostApiBorrowersDisconnectQuickbooksError = unknown;

export type PostApiBorrowersDisconnectPlaidResponse = (unknown);

export type PostApiBorrowersDisconnectPlaidError = unknown;

export type PostApiBorrowersFinishQuickbooksLinkData = {
    query?: {
        code?: string;
        realmId?: string;
    };
};

export type PostApiBorrowersFinishQuickbooksLinkResponse = (unknown);

export type PostApiBorrowersFinishQuickbooksLinkError = unknown;

export type GetApiBorrowersListTransactionsResponse = (Array<Transaction>);

export type GetApiBorrowersListTransactionsError = unknown;

export type PostApiBorrowersAnalyzeBankStatementsResponse = (unknown);

export type PostApiBorrowersAnalyzeBankStatementsError = unknown;

export type PostApiBorrowersExchangePlaidTokenData = {
    query?: {
        publicToken?: string;
    };
};

export type PostApiBorrowersExchangePlaidTokenResponse = (unknown);

export type PostApiBorrowersExchangePlaidTokenError = unknown;

export type GetApiBorrowersUsersResponse = (Array<BorrowerViewModel>);

export type GetApiBorrowersUsersError = unknown;

export type PostApiBorrowersRemoveUserData = {
    query?: {
        userId?: number;
    };
};

export type PostApiBorrowersRemoveUserResponse = (unknown);

export type PostApiBorrowersRemoveUserError = unknown;

export type PostApiBorrowersChangeUserAccessData = {
    query?: {
        access?: BorrowerAccess;
        userId?: number;
    };
};

export type PostApiBorrowersChangeUserAccessResponse = (unknown);

export type PostApiBorrowersChangeUserAccessError = unknown;

export type GetApiBorrowersGetAllResponse = (Array<BorrowerViewModel>);

export type GetApiBorrowersGetAllError = unknown;

export type GetApiBorrowersGetBorrowersResponse = (Array<BorrowerViewModel>);

export type GetApiBorrowersGetBorrowersError = unknown;

export type GetApiBorrowersGetRsgDashboardViewmodelResponse = (RsgDashboardViewmodel);

export type GetApiBorrowersGetRsgDashboardViewmodelError = unknown;

export type PostApiBorrowersLandingPageApplyData = {
    query?: {
        evalId?: string;
    };
};

export type PostApiBorrowersLandingPageApplyResponse = (string);

export type PostApiBorrowersLandingPageApplyError = unknown;

export type GetApiBorrowersGetBorrowerUsersData = {
    query?: {
        borrowerId?: string;
    };
};

export type GetApiBorrowersGetBorrowerUsersResponse = (Array<BorrowerUserViewModel>);

export type GetApiBorrowersGetBorrowerUsersError = unknown;

export type PostApiBorrowersSetActiveBorrowerData = {
    query?: {
        borrowerId?: string;
    };
};

export type PostApiBorrowersSetActiveBorrowerResponse = (unknown);

export type PostApiBorrowersSetActiveBorrowerError = unknown;

export type GetApiBorrowersGetGlossaryResponse = ({
    [key: string]: StringStringTuple;
});

export type GetApiBorrowersGetGlossaryError = unknown;

export type PostApiBorrowersAcceptTermsData = {
    query?: {
        name?: string;
    };
};

export type PostApiBorrowersAcceptTermsResponse = (unknown);

export type PostApiBorrowersAcceptTermsError = unknown;

export type PostApiBorrowersEvaluateLandingData = {
    body?: EvaluationInput;
    query?: {
        existingId?: string;
        findBestLoanType?: boolean;
    };
};

export type PostApiBorrowersEvaluateLandingResponse = (LandingLegacyEvaluationResponse);

export type PostApiBorrowersEvaluateLandingError = unknown;

export type GetApiBorrowersEvaluateFundingOptionsData = {
    query?: {
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type GetApiBorrowersEvaluateFundingOptionsResponse = (LandingEvaluationResponse);

export type GetApiBorrowersEvaluateFundingOptionsError = unknown;

export type PostApiBorrowersEvaluateFundingOptionsData = {
    body?: EvaluationInput;
};

export type PostApiBorrowersEvaluateFundingOptionsResponse = (LandingEvaluationResponse);

export type PostApiBorrowersEvaluateFundingOptionsError = unknown;

export type GetApiBorrowersEvaluateBorrowerFundingOptionsData = {
    query?: {
        borrowerId?: string;
        portal?: PortalType;
    };
};

export type GetApiBorrowersEvaluateBorrowerFundingOptionsResponse = (LandingEvaluationResponse);

export type GetApiBorrowersEvaluateBorrowerFundingOptionsError = unknown;

export type GetApiBorrowersEvaluateData = {
    query?: {
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type GetApiBorrowersEvaluateResponse = (EvaluationResult);

export type GetApiBorrowersEvaluateError = unknown;

export type PostApiBorrowersAdminAddBorrowerUserData = {
    query?: {
        borrowerId?: string;
        userId?: number;
    };
};

export type PostApiBorrowersAdminAddBorrowerUserResponse = (unknown);

export type PostApiBorrowersAdminAddBorrowerUserError = unknown;

export type GetApiBorrowersCashBasedProfitLossReportData = {
    query?: {
        borrowerId?: string;
        portalType?: PortalType;
    };
};

export type GetApiBorrowersCashBasedProfitLossReportResponse = (Array<MonthCashBasedProfitLossReport>);

export type GetApiBorrowersCashBasedProfitLossReportError = unknown;

export type GetApiBorrowersActiveCashBasedProfitLossReportData = {
    query?: {
        borrowerId?: string;
        portalType?: PortalType;
    };
};

export type GetApiBorrowersActiveCashBasedProfitLossReportResponse = (Array<MonthCashBasedProfitLossReport>);

export type GetApiBorrowersActiveCashBasedProfitLossReportError = unknown;

export type GetApiBorrowersBorrowerDetailsResponse = (BorrowerViewModel);

export type GetApiBorrowersBorrowerDetailsError = unknown;

export type GetApiBorrowersGetBorrowerAdditionalFilesData = {
    query?: {
        borrowerId?: string;
        portalType?: PortalType;
    };
};

export type GetApiBorrowersGetBorrowerAdditionalFilesResponse = (Array<FileViewModel>);

export type GetApiBorrowersGetBorrowerAdditionalFilesError = unknown;

export type GetApiBorrowersGetBorrowerProfileFilesResponse = (Array<FileViewModel>);

export type GetApiBorrowersGetBorrowerProfileFilesError = unknown;

export type PostApiBorrowersMoveProfileFileData = {
    query?: {
        borrowerId?: string;
        fileId?: string;
        targetFileType?: ProfileFileType;
    };
};

export type PostApiBorrowersMoveProfileFileResponse = (unknown);

export type PostApiBorrowersMoveProfileFileError = unknown;

export type PostApiBorrowersUploadBorrowerProfileFileData = {
    query?: {
        borrowerId?: string;
        contentType?: string;
        fileName?: string;
        fileType?: string;
    };
};

export type PostApiBorrowersUploadBorrowerProfileFileResponse = (FileUploadResponse);

export type PostApiBorrowersUploadBorrowerProfileFileError = unknown;

export type PostApiBorrowersRenameProfileFileData = {
    query?: {
        fileId?: string;
        name?: string;
    };
};

export type PostApiBorrowersRenameProfileFileResponse = (unknown);

export type PostApiBorrowersRenameProfileFileError = unknown;

export type PostApiBorrowersApproveAdditionalFileData = {
    body?: FileApprovalRequest;
    query?: {
        fileId?: string;
    };
};

export type PostApiBorrowersApproveAdditionalFileResponse = (unknown);

export type PostApiBorrowersApproveAdditionalFileError = unknown;

export type PostApiBorrowersRenameAdditionalFileData = {
    query?: {
        fileId?: string;
        name?: string;
    };
};

export type PostApiBorrowersRenameAdditionalFileResponse = (unknown);

export type PostApiBorrowersRenameAdditionalFileError = unknown;

export type PostApiBorrowersUploadBorrowerAdditionalFileData = {
    query?: {
        borrowerId?: string;
    };
};

export type PostApiBorrowersUploadBorrowerAdditionalFileResponse = (Array<FileViewModel>);

export type PostApiBorrowersUploadBorrowerAdditionalFileError = unknown;

export type PostApiBorrowersDeleteBorrowerData = {
    query?: {
        borrowerId?: string;
    };
};

export type PostApiBorrowersDeleteBorrowerResponse = (unknown);

export type PostApiBorrowersDeleteBorrowerError = unknown;

export type PostApiBorrowersDeleteBorrowerAdditionalFileData = {
    query?: {
        borrowerId?: string;
        fileId?: string;
    };
};

export type PostApiBorrowersDeleteBorrowerAdditionalFileResponse = (unknown);

export type PostApiBorrowersDeleteBorrowerAdditionalFileError = unknown;

export type PostApiBorrowersDeleteBorrowerProfileFileData = {
    query?: {
        borrowerId?: string;
        fileId?: string;
    };
};

export type PostApiBorrowersDeleteBorrowerProfileFileResponse = (unknown);

export type PostApiBorrowersDeleteBorrowerProfileFileError = unknown;

export type GetApiBorrowersDownloadAdditionalFileData = {
    query?: {
        borrowerId?: string;
        fileId?: string;
        portalType?: PortalType;
    };
};

export type GetApiBorrowersDownloadAdditionalFileResponse = (unknown);

export type GetApiBorrowersDownloadAdditionalFileError = unknown;

export type GetApiBorrowersDownloadProfileFileData = {
    query?: {
        borrowerId?: string;
        fileId?: string;
        portalType?: PortalType;
    };
};

export type GetApiBorrowersDownloadProfileFileResponse = (unknown);

export type GetApiBorrowersDownloadProfileFileError = unknown;

export type PostApiBorrowersCreateAdditionalBorrowerResponse = (unknown);

export type PostApiBorrowersCreateAdditionalBorrowerError = unknown;

export type PostApiBorrowersOnboardAdditionalBorrowerData = {
    query?: {
        evalId?: string;
    };
};

export type PostApiBorrowersOnboardAdditionalBorrowerResponse = (unknown);

export type PostApiBorrowersOnboardAdditionalBorrowerError = unknown;

export type PostApiBorrowersOnboardBorrowerData = {
    body?: LandingPageEvaluation;
};

export type PostApiBorrowersOnboardBorrowerResponse = (unknown);

export type PostApiBorrowersOnboardBorrowerError = unknown;

export type PostApiBorrowersUpdateCompanyNameData = {
    body?: UpdateCompanyNameRequest;
    query?: {
        borrowerId?: string;
    };
};

export type PostApiBorrowersUpdateCompanyNameResponse = (unknown);

export type PostApiBorrowersUpdateCompanyNameError = unknown;

export type PostApiBorrowersUpdateBorrowerProfileData = {
    body?: BorrowerProfile;
    query?: {
        borrowerId?: string;
        percentComplete?: number;
    };
};

export type PostApiBorrowersUpdateBorrowerProfileResponse = (unknown);

export type PostApiBorrowersUpdateBorrowerProfileError = unknown;

export type GetApiEvaluationLoanSimulatorHistoryResponse = (Array<LandingPageEvaluationViewModel>);

export type GetApiEvaluationLoanSimulatorHistoryError = unknown;

export type GetApiLendersLenderGroupsResponse = (Array<LenderGroupViewModel>);

export type GetApiLendersLenderGroupsError = unknown;

export type GetApiLendersGroupLendersData = {
    query?: {
        groupId?: string;
    };
};

export type GetApiLendersGroupLendersResponse = (Array<LenderViewModel>);

export type GetApiLendersGroupLendersError = unknown;

export type PostApiLendersCreateLenderGroupData = {
    query?: {
        name?: string;
    };
};

export type PostApiLendersCreateLenderGroupResponse = (unknown);

export type PostApiLendersCreateLenderGroupError = unknown;

export type GetApiLendersLoansForLenderGroupData = {
    query?: {
        groupId?: string;
    };
};

export type GetApiLendersLoansForLenderGroupResponse = (Array<LoanApplicationViewModel>);

export type GetApiLendersLoansForLenderGroupError = unknown;

export type PostApiLendersRemoveLenderFromGroupData = {
    query?: {
        groupId?: string;
        lenderId?: string;
    };
};

export type PostApiLendersRemoveLenderFromGroupResponse = (unknown);

export type PostApiLendersRemoveLenderFromGroupError = unknown;

export type PostApiLendersAssignLenderToGroupData = {
    query?: {
        groupId?: string;
        lenderId?: string;
    };
};

export type PostApiLendersAssignLenderToGroupResponse = (unknown);

export type PostApiLendersAssignLenderToGroupError = unknown;

export type GetApiLendersProfileFilesData = {
    query?: {
        lenderId?: string;
    };
};

export type GetApiLendersProfileFilesResponse = (Array<FileViewModel>);

export type GetApiLendersProfileFilesError = unknown;

export type PostApiLendersRemoveLenderUserData = {
    query?: {
        userId?: number;
    };
};

export type PostApiLendersRemoveLenderUserResponse = (unknown);

export type PostApiLendersRemoveLenderUserError = unknown;

export type PostApiLendersUpdateLenderGroupData = {
    body?: LenderGroupViewModel;
    query?: {
        groupId?: string;
    };
};

export type PostApiLendersUpdateLenderGroupResponse = (unknown);

export type PostApiLendersUpdateLenderGroupError = unknown;

export type PostApiLendersUpdateLenderUserData = {
    query?: {
        lenderUserType?: LenderUserType;
        userId?: number;
    };
};

export type PostApiLendersUpdateLenderUserResponse = (unknown);

export type PostApiLendersUpdateLenderUserError = unknown;

export type PostApiLendersUploadLenderProfileFileData = {
    query?: {
        contentType?: string;
        fileName?: string;
        lenderId?: string;
    };
};

export type PostApiLendersUploadLenderProfileFileResponse = (FileUploadResponse);

export type PostApiLendersUploadLenderProfileFileError = unknown;

export type PostApiLendersRenameLenderProfileFileData = {
    query?: {
        fileId?: string;
        name?: string;
    };
};

export type PostApiLendersRenameLenderProfileFileResponse = (unknown);

export type PostApiLendersRenameLenderProfileFileError = unknown;

export type PostApiLendersDeleteLenderProfileFileData = {
    query?: {
        fileId?: string;
        lenderId?: string;
    };
};

export type PostApiLendersDeleteLenderProfileFileResponse = (unknown);

export type PostApiLendersDeleteLenderProfileFileError = unknown;

export type PostApiLendersDownloadLenderProfileFileData = {
    query?: {
        fileId?: string;
        lenderId?: string;
    };
};

export type PostApiLendersDownloadLenderProfileFileResponse = (string);

export type PostApiLendersDownloadLenderProfileFileError = unknown;

export type PostApiLendersSpecialistRemoveLenderUserData = {
    query?: {
        lenderId?: string;
        userId?: number;
    };
};

export type PostApiLendersSpecialistRemoveLenderUserResponse = (unknown);

export type PostApiLendersSpecialistRemoveLenderUserError = unknown;

export type PostApiLendersSpecialistAddLenderUserData = {
    query?: {
        lenderId?: string;
        userId?: number;
    };
};

export type PostApiLendersSpecialistAddLenderUserResponse = (unknown);

export type PostApiLendersSpecialistAddLenderUserError = unknown;

export type GetApiLendersGetLenderUsersData = {
    query?: {
        lenderId?: string;
    };
};

export type GetApiLendersGetLenderUsersResponse = (Array<UserViewModel>);

export type GetApiLendersGetLenderUsersError = unknown;

export type PostApiLendersSetMatchingEnabledData = {
    query?: {
        enabled?: boolean;
        lenderId?: string;
    };
};

export type PostApiLendersSetMatchingEnabledResponse = (unknown);

export type PostApiLendersSetMatchingEnabledError = unknown;

export type GetApiLendersSpecialistReadLenderProfileData = {
    query?: {
        lenderId?: number;
    };
};

export type GetApiLendersSpecialistReadLenderProfileResponse = (LenderProfileViewModel);

export type GetApiLendersSpecialistReadLenderProfileError = unknown;

export type GetApiLendersGetCurrentLenderUsersResponse = (Array<LenderUserViewModel>);

export type GetApiLendersGetCurrentLenderUsersError = unknown;

export type GetApiLendersSpecialistGetLenderProfileData = {
    query?: {
        lenderId?: string;
    };
};

export type GetApiLendersSpecialistGetLenderProfileResponse = (SpecialistLenderProfileModel);

export type GetApiLendersSpecialistGetLenderProfileError = unknown;

export type GetApiLendersGetLenderProfileResponse = (LenderProfileViewModel);

export type GetApiLendersGetLenderProfileError = unknown;

export type GetApiLendersGetFullLenderExportResponse = (unknown);

export type GetApiLendersGetFullLenderExportError = unknown;

export type GetApiLendersGetLoanHistoryExportResponse = (unknown);

export type GetApiLendersGetLoanHistoryExportError = unknown;

export type GetApiLendersGetWidgetHistoryExportResponse = (unknown);

export type GetApiLendersGetWidgetHistoryExportError = unknown;

export type PostApiLendersDeleteLenderData = {
    query?: {
        lenderId?: string;
    };
};

export type PostApiLendersDeleteLenderResponse = (unknown);

export type PostApiLendersDeleteLenderError = unknown;

export type GetApiLendersAllResponse = (Array<LenderViewModel>);

export type GetApiLendersAllError = unknown;

export type GetApiLendersGetCovenantsResponse = (Array<CovenantViewModel>);

export type GetApiLendersGetCovenantsError = unknown;

export type GetApiLendersGetCollateralsResponse = (Array<CovenantViewModel>);

export type GetApiLendersGetCollateralsError = unknown;

export type PostApiLendersCreateNewLenderData = {
    query?: {
        lenderName?: string;
    };
};

export type PostApiLendersCreateNewLenderResponse = (unknown);

export type PostApiLendersCreateNewLenderError = unknown;

export type PostApiLendersCreateCollateralData = {
    body?: CovenantViewModel;
};

export type PostApiLendersCreateCollateralResponse = (CovenantViewModel);

export type PostApiLendersCreateCollateralError = unknown;

export type PostApiLendersSetActiveLenderData = {
    query?: {
        lenderId?: string;
    };
};

export type PostApiLendersSetActiveLenderResponse = (unknown);

export type PostApiLendersSetActiveLenderError = unknown;

export type PostApiLendersCreateCovenantData = {
    body?: CovenantViewModel;
};

export type PostApiLendersCreateCovenantResponse = (CovenantViewModel);

export type PostApiLendersCreateCovenantError = unknown;

export type GetApiLendersGetLenderCriteriaData = {
    query?: {
        lenderId?: string;
    };
};

export type GetApiLendersGetLenderCriteriaResponse = (FullLenderCriteriaResponse);

export type GetApiLendersGetLenderCriteriaError = unknown;

export type GetApiLendersLenderAdminResponse = (LenderAdminViewModel);

export type GetApiLendersLenderAdminError = unknown;

export type PostApiLendersUpdateLenderAdminData = {
    body?: LenderAdminViewModel;
};

export type PostApiLendersUpdateLenderAdminResponse = (unknown);

export type PostApiLendersUpdateLenderAdminError = unknown;

export type PostApiLendersUpdateLoanAccessUsersData = {
    body?: UpdateLoanAccessRequest;
    query?: {
        loanId?: string;
    };
};

export type PostApiLendersUpdateLoanAccessUsersResponse = (unknown);

export type PostApiLendersUpdateLoanAccessUsersError = unknown;

export type GetApiLendersLoanAccessUsersData = {
    query?: {
        loanId?: string;
    };
};

export type GetApiLendersLoanAccessUsersResponse = (Array<LenderUserViewModel>);

export type GetApiLendersLoanAccessUsersError = unknown;

export type GetApiLendersCurrentRatesResponse = ({
    Absolute?: number;
    LIBOR?: number;
    SOFR?: number;
    Prime?: number;
});

export type GetApiLendersCurrentRatesError = unknown;

export type GetApiLendersLenderProfileNotesData = {
    query?: {
        lenderId?: string;
    };
};

export type GetApiLendersLenderProfileNotesResponse = (Array<NoteViewmodel>);

export type GetApiLendersLenderProfileNotesError = unknown;

export type GetApiLendersLenderCriteriaReportResponse = (Array<LenderCriteriaReportViewModel>);

export type GetApiLendersLenderCriteriaReportError = unknown;

export type GetApiLendersGetLenderLoansData = {
    query?: {
        lenderId?: string;
    };
};

export type GetApiLendersGetLenderLoansResponse = (Array<LoanApplicationViewModel>);

export type GetApiLendersGetLenderLoansError = unknown;

export type PostApiLendersAddLenderProfileNoteData = {
    body?: NotesData;
    query?: {
        lenderId?: string;
    };
};

export type PostApiLendersAddLenderProfileNoteResponse = (unknown);

export type PostApiLendersAddLenderProfileNoteError = unknown;

export type PostApiLendersSpecialistUpdateLenderProfileData = {
    body?: SpecialistLenderProfileModel;
    query?: {
        lenderId?: string;
    };
};

export type PostApiLendersSpecialistUpdateLenderProfileResponse = (unknown);

export type PostApiLendersSpecialistUpdateLenderProfileError = unknown;

export type PostApiLendersUpdateLenderProfileData = {
    body?: LenderProfileViewModel;
};

export type PostApiLendersUpdateLenderProfileResponse = (unknown);

export type PostApiLendersUpdateLenderProfileError = unknown;

export type PostApiLendersUpdateLenderCriteriaData = {
    body?: FullLenderCriteria;
    query?: {
        lenderId?: string;
    };
};

export type PostApiLendersUpdateLenderCriteriaResponse = (unknown);

export type PostApiLendersUpdateLenderCriteriaError = unknown;

export type PostApiLenderApplicationsExpressInterestData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLenderApplicationsExpressInterestResponse = (unknown);

export type PostApiLenderApplicationsExpressInterestError = unknown;

export type PostApiLenderApplicationsSpecialistUpdateUnderwritingStateData = {
    query?: {
        comment?: string;
        lenderId?: string;
        loanAppId?: string;
        underwritingState?: LenderApplicationUnderwritingState;
    };
};

export type PostApiLenderApplicationsSpecialistUpdateUnderwritingStateResponse = (unknown);

export type PostApiLenderApplicationsSpecialistUpdateUnderwritingStateError = unknown;

export type PostApiLenderApplicationsSpecialistExpressInterestData = {
    query?: {
        lenderId?: string;
        loanAppId?: string;
    };
};

export type PostApiLenderApplicationsSpecialistExpressInterestResponse = (unknown);

export type PostApiLenderApplicationsSpecialistExpressInterestError = unknown;

export type PostApiLenderApplicationsAddLenderApplicationNoteData = {
    body?: NotesData;
    query?: {
        lenderId?: string;
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type PostApiLenderApplicationsAddLenderApplicationNoteResponse = (unknown);

export type PostApiLenderApplicationsAddLenderApplicationNoteError = unknown;

export type GetApiLenderApplicationsGetLenderApplicationNotesData = {
    query?: {
        lenderId?: string;
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type GetApiLenderApplicationsGetLenderApplicationNotesResponse = (Array<NoteViewmodel>);

export type GetApiLenderApplicationsGetLenderApplicationNotesError = unknown;

export type GetApiLenderApplicationsGetLenderAppAuditLogData = {
    query?: {
        lenderId?: string;
        loanAppId?: string;
    };
};

export type GetApiLenderApplicationsGetLenderAppAuditLogResponse = (Array<AuditViewModel>);

export type GetApiLenderApplicationsGetLenderAppAuditLogError = unknown;

export type PostApiLoanApplicationsRefreshBorrowerProfileData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsRefreshBorrowerProfileResponse = (unknown);

export type PostApiLoanApplicationsRefreshBorrowerProfileError = unknown;

export type GetApiLoanApplicationsImportantAuditData = {
    query?: {
        sinceDate?: number;
    };
};

export type GetApiLoanApplicationsImportantAuditResponse = (Array<AuditViewModel>);

export type GetApiLoanApplicationsImportantAuditError = unknown;

export type GetApiLoanApplicationsSupervisorLoansResponse = (Array<LoanApplicationViewModel>);

export type GetApiLoanApplicationsSupervisorLoansError = unknown;

export type GetApiLoanApplicationsGetLoanAuditLogData = {
    query?: {
        loanAppId?: string;
    };
};

export type GetApiLoanApplicationsGetLoanAuditLogResponse = (Array<AuditViewModel>);

export type GetApiLoanApplicationsGetLoanAuditLogError = unknown;

export type GetApiLoanApplicationsGetAllLoansData = {
    query?: {
        specialistId?: number;
    };
};

export type GetApiLoanApplicationsGetAllLoansResponse = (Array<LoanApplicationViewModel>);

export type GetApiLoanApplicationsGetAllLoansError = unknown;

export type GetApiLoanApplicationsActiveLoansResponse = (Array<LoanApplicationViewModel>);

export type GetApiLoanApplicationsActiveLoansError = unknown;

export type PostApiLoanApplicationsAdminOverrideStatusData = {
    query?: {
        comment?: string;
        loanAppId?: string;
        status?: LoanApplicationStatus;
    };
};

export type PostApiLoanApplicationsAdminOverrideStatusResponse = (unknown);

export type PostApiLoanApplicationsAdminOverrideStatusError = unknown;

export type PostApiLoanApplicationsCancelLoanData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsCancelLoanResponse = (unknown);

export type PostApiLoanApplicationsCancelLoanError = unknown;

export type PostApiLoanApplicationsSubmitSignedClosingFilesData = {
    query?: {
        loanAppId?: string;
        offerId?: string;
    };
};

export type PostApiLoanApplicationsSubmitSignedClosingFilesResponse = (unknown);

export type PostApiLoanApplicationsSubmitSignedClosingFilesError = unknown;

export type PostApiLoanApplicationsSubmitClosingFilesData = {
    query?: {
        loanAppId?: string;
        offerId?: string;
    };
};

export type PostApiLoanApplicationsSubmitClosingFilesResponse = (unknown);

export type PostApiLoanApplicationsSubmitClosingFilesError = unknown;

export type PostApiLoanApplicationsSubmitFinalClosingFilesData = {
    query?: {
        loanAppId?: string;
        offerId?: string;
    };
};

export type PostApiLoanApplicationsSubmitFinalClosingFilesResponse = (unknown);

export type PostApiLoanApplicationsSubmitFinalClosingFilesError = unknown;

export type GetApiLoanApplicationsOutgoingLenderApplicationsData = {
    query?: {
        specialistId?: number;
    };
};

export type GetApiLoanApplicationsOutgoingLenderApplicationsResponse = (Array<LoanApplicationViewModel>);

export type GetApiLoanApplicationsOutgoingLenderApplicationsError = unknown;

export type PostApiLoanApplicationsSpecialistDeclineLoanData = {
    query?: {
        comment?: string;
        lenderId?: string;
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsSpecialistDeclineLoanResponse = (unknown);

export type PostApiLoanApplicationsSpecialistDeclineLoanError = unknown;

export type PostApiLoanApplicationsApproveSignedClosingData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsApproveSignedClosingResponse = (unknown);

export type PostApiLoanApplicationsApproveSignedClosingError = unknown;

export type PostApiLoanApplicationsDeclineLoanData = {
    query?: {
        comment?: string;
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsDeclineLoanResponse = (unknown);

export type PostApiLoanApplicationsDeclineLoanError = unknown;

export type PostApiLoanApplicationsDeclineSignedClosingData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsDeclineSignedClosingResponse = (unknown);

export type PostApiLoanApplicationsDeclineSignedClosingError = unknown;

export type PostApiLoanApplicationsApproveClosingData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsApproveClosingResponse = (unknown);

export type PostApiLoanApplicationsApproveClosingError = unknown;

export type PostApiLoanApplicationsDeclineClosingData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsDeclineClosingResponse = (unknown);

export type PostApiLoanApplicationsDeclineClosingError = unknown;

export type PostApiLoanApplicationsApproveFinalClosingDocsData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsApproveFinalClosingDocsResponse = (unknown);

export type PostApiLoanApplicationsApproveFinalClosingDocsError = unknown;

export type PostApiLoanApplicationsConfirmFundingData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsConfirmFundingResponse = (unknown);

export type PostApiLoanApplicationsConfirmFundingError = unknown;

export type PostApiLoanApplicationsMarkLoanNotFundedData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsMarkLoanNotFundedResponse = (unknown);

export type PostApiLoanApplicationsMarkLoanNotFundedError = unknown;

export type PostApiLoanApplicationsCloseLoanData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsCloseLoanResponse = (unknown);

export type PostApiLoanApplicationsCloseLoanError = unknown;

export type PostApiLoanApplicationsApproveSignedBindingData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsApproveSignedBindingResponse = (unknown);

export type PostApiLoanApplicationsApproveSignedBindingError = unknown;

export type PostApiLoanApplicationsWithdrawLenderFromLoanData = {
    query?: {
        lenderId?: string;
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsWithdrawLenderFromLoanResponse = (unknown);

export type PostApiLoanApplicationsWithdrawLenderFromLoanError = unknown;

export type PostApiLoanApplicationsDeclineSignedBindingData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsDeclineSignedBindingResponse = (unknown);

export type PostApiLoanApplicationsDeclineSignedBindingError = unknown;

export type PostApiLoanApplicationsSpecialistUpdateLoanAskData = {
    body?: LoanAsk;
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsSpecialistUpdateLoanAskResponse = (unknown);

export type PostApiLoanApplicationsSpecialistUpdateLoanAskError = unknown;

export type PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteData = {
    query?: {
        id?: string;
        message?: string;
    };
};

export type PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteResponse = (unknown);

export type PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteError = unknown;

export type GetApiLoanApplicationsGetAdditionalFilesData = {
    query?: {
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type GetApiLoanApplicationsGetAdditionalFilesResponse = (Array<AdditionalFileViewModel>);

export type GetApiLoanApplicationsGetAdditionalFilesError = unknown;

export type PostApiLoanApplicationsUpdateLoanApplicationOnHoldData = {
    query?: {
        id?: string;
        message?: string;
        onHold?: boolean;
    };
};

export type PostApiLoanApplicationsUpdateLoanApplicationOnHoldResponse = (unknown);

export type PostApiLoanApplicationsUpdateLoanApplicationOnHoldError = unknown;

export type GetApiLoanApplicationsChartLoanDataResponse = (LoanChartDataResponse);

export type GetApiLoanApplicationsChartLoanDataError = unknown;

export type GetApiLoanApplicationsChartTermSheetDataResponse = (Array<LoanOfferViewModel>);

export type GetApiLoanApplicationsChartTermSheetDataError = unknown;

export type PostApiLoanApplicationsRevertTermSheetData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsRevertTermSheetResponse = (unknown);

export type PostApiLoanApplicationsRevertTermSheetError = unknown;

export type PostApiLoanApplicationsUpdateOfferDeadlineData = {
    query?: {
        deadline?: number;
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsUpdateOfferDeadlineResponse = (unknown);

export type PostApiLoanApplicationsUpdateOfferDeadlineError = unknown;

export type GetApiLoanApplicationsGetLenderLoanAuditData = {
    query?: {
        loanAppId?: string;
    };
};

export type GetApiLoanApplicationsGetLenderLoanAuditResponse = (Array<AuditViewModel>);

export type GetApiLoanApplicationsGetLenderLoanAuditError = unknown;

export type GetApiLoanApplicationsGetBorrowerReviewFilesData = {
    query?: {
        loanAppId?: string;
    };
};

export type GetApiLoanApplicationsGetBorrowerReviewFilesResponse = (Array<FileViewModel>);

export type GetApiLoanApplicationsGetBorrowerReviewFilesError = unknown;

export type PostApiLoanApplicationsDeleteBorrowerReviewFileData = {
    query?: {
        fileId?: string;
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsDeleteBorrowerReviewFileResponse = (unknown);

export type PostApiLoanApplicationsDeleteBorrowerReviewFileError = unknown;

export type PostApiLoanApplicationsUploadBorrowerReviewFilesData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsUploadBorrowerReviewFilesResponse = (unknown);

export type PostApiLoanApplicationsUploadBorrowerReviewFilesError = unknown;

export type PostApiLoanApplicationsRequestLenderSubmissionData = {
    body?: LoanApplicationSubmitModel;
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsRequestLenderSubmissionResponse = (unknown);

export type PostApiLoanApplicationsRequestLenderSubmissionError = unknown;

export type PostApiLoanApplicationsUploadAdditionalFileData = {
    query?: {
        contentType?: string;
        fileName?: string;
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type PostApiLoanApplicationsUploadAdditionalFileResponse = (FileUploadResponse);

export type PostApiLoanApplicationsUploadAdditionalFileError = unknown;

export type PostApiLoanApplicationsDeleteAdditionalFileData = {
    query?: {
        fileId?: string;
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type PostApiLoanApplicationsDeleteAdditionalFileResponse = (unknown);

export type PostApiLoanApplicationsDeleteAdditionalFileError = unknown;

export type GetApiLoanApplicationsGetAcceptedOffersData = {
    query?: {
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type GetApiLoanApplicationsGetAcceptedOffersResponse = (Array<LoanOfferViewModel>);

export type GetApiLoanApplicationsGetAcceptedOffersError = unknown;

export type GetApiLoanApplicationsDownloadAdditionalFileData = {
    query?: {
        fileId?: string;
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type GetApiLoanApplicationsDownloadAdditionalFileResponse = (unknown);

export type GetApiLoanApplicationsDownloadAdditionalFileError = unknown;

export type GetApiLoanApplicationsGetBorrowerTemplateExportData = {
    query?: {
        loanAppId?: string;
        templateId?: string;
    };
};

export type GetApiLoanApplicationsGetBorrowerTemplateExportResponse = (unknown);

export type GetApiLoanApplicationsGetBorrowerTemplateExportError = unknown;

export type PostApiLoanApplicationsGetBorrowerPackageExportData = {
    query?: {
        loanAppId?: string;
        portalType?: PortalType;
        sheetOnly?: boolean;
    };
};

export type PostApiLoanApplicationsGetBorrowerPackageExportResponse = (string);

export type PostApiLoanApplicationsGetBorrowerPackageExportError = unknown;

export type GetApiLoanApplicationsLenderReferredLoansResponse = (Array<LoanApplicationViewModel>);

export type GetApiLoanApplicationsLenderReferredLoansError = unknown;

export type PostApiLoanApplicationsGenerateLenderSummaryData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsGenerateLenderSummaryResponse = (unknown);

export type PostApiLoanApplicationsGenerateLenderSummaryError = unknown;

export type PostApiLoanApplicationsGenerateLoanPreviewData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsGenerateLoanPreviewResponse = (unknown);

export type PostApiLoanApplicationsGenerateLoanPreviewError = unknown;

export type PostApiLoanApplicationsUpdateLoanPreviewData = {
    body?: LoanPreviewContent;
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsUpdateLoanPreviewResponse = (unknown);

export type PostApiLoanApplicationsUpdateLoanPreviewError = unknown;

export type GetApiLoanApplicationsDownloadFinancialExportData = {
    query?: {
        loanApplicationId?: string;
        portalType?: PortalType;
    };
};

export type GetApiLoanApplicationsDownloadFinancialExportResponse = (unknown);

export type GetApiLoanApplicationsDownloadFinancialExportError = unknown;

export type GetApiLoanApplicationsGetLoanApplicationsResponse = (Array<LoanApplicationViewModel>);

export type GetApiLoanApplicationsGetLoanApplicationsError = unknown;

export type GetApiLoanApplicationsSpecialistGetBorrowerLoanApplicationsData = {
    query?: {
        borrowerId?: string;
    };
};

export type GetApiLoanApplicationsSpecialistGetBorrowerLoanApplicationsResponse = (Array<LoanApplicationViewModel>);

export type GetApiLoanApplicationsSpecialistGetBorrowerLoanApplicationsError = unknown;

export type PostApiLoanApplicationsSetExpectedCloseDateData = {
    query?: {
        closeDate?: number;
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsSetExpectedCloseDateResponse = (unknown);

export type PostApiLoanApplicationsSetExpectedCloseDateError = unknown;

export type PostApiLoanApplicationsSetExpectedFundsDateData = {
    query?: {
        fundsDate?: number;
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsSetExpectedFundsDateResponse = (unknown);

export type PostApiLoanApplicationsSetExpectedFundsDateError = unknown;

export type PostApiLoanApplicationsRevertAttestationData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsRevertAttestationResponse = (unknown);

export type PostApiLoanApplicationsRevertAttestationError = unknown;

export type PostApiLoanApplicationsReviewSubmissionData = {
    query?: {
        approved?: boolean;
        comment?: string;
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsReviewSubmissionResponse = (unknown);

export type PostApiLoanApplicationsReviewSubmissionError = unknown;

export type PostApiLoanApplicationsUpdateLoanApplicationData = {
    body?: LoanApplicationViewModel;
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsUpdateLoanApplicationResponse = (unknown);

export type PostApiLoanApplicationsUpdateLoanApplicationError = unknown;

export type PostApiLoanApplicationsAttestLoanApplicationData = {
    query?: {
        isReattest?: boolean;
        loanAppId?: string;
        name?: string;
        title?: string;
    };
};

export type PostApiLoanApplicationsAttestLoanApplicationResponse = (unknown);

export type PostApiLoanApplicationsAttestLoanApplicationError = unknown;

export type PostApiLoanApplicationsCompleteOnboardingData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsCompleteOnboardingResponse = (unknown);

export type PostApiLoanApplicationsCompleteOnboardingError = unknown;

export type PostApiLoanApplicationsCompleteManualStepData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsCompleteManualStepResponse = (unknown);

export type PostApiLoanApplicationsCompleteManualStepError = unknown;

export type GetApiLoanApplicationsGetEngagedLendersData = {
    query?: {
        loanAppId?: string;
    };
};

export type GetApiLoanApplicationsGetEngagedLendersResponse = (Array<LenderViewModel>);

export type GetApiLoanApplicationsGetEngagedLendersError = unknown;

export type PostApiLoanApplicationsApproveAdditionalFileData = {
    body?: FileApprovalRequest;
    query?: {
        fileId?: string;
    };
};

export type PostApiLoanApplicationsApproveAdditionalFileResponse = (unknown);

export type PostApiLoanApplicationsApproveAdditionalFileError = unknown;

export type PostApiLoanApplicationsRenameAdditionalFileData = {
    query?: {
        fileId?: string;
        name?: string;
    };
};

export type PostApiLoanApplicationsRenameAdditionalFileResponse = (unknown);

export type PostApiLoanApplicationsRenameAdditionalFileError = unknown;

export type GetApiLoanApplicationsGetApplicationNotesData = {
    query?: {
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type GetApiLoanApplicationsGetApplicationNotesResponse = (Array<NoteViewmodel>);

export type GetApiLoanApplicationsGetApplicationNotesError = unknown;

export type PostApiLoanApplicationsUpdateApplicationNoteData = {
    body?: NotesData;
    query?: {
        loanAppId?: string;
        noteId?: string;
        portalType?: PortalType;
    };
};

export type PostApiLoanApplicationsUpdateApplicationNoteResponse = (unknown);

export type PostApiLoanApplicationsUpdateApplicationNoteError = unknown;

export type PostApiLoanApplicationsDeleteApplicationNoteData = {
    query?: {
        loanAppId?: string;
        noteId?: string;
        portalType?: PortalType;
    };
};

export type PostApiLoanApplicationsDeleteApplicationNoteResponse = (unknown);

export type PostApiLoanApplicationsDeleteApplicationNoteError = unknown;

export type PostApiLoanApplicationsAddApplicationNoteData = {
    body?: NotesData;
    query?: {
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type PostApiLoanApplicationsAddApplicationNoteResponse = (unknown);

export type PostApiLoanApplicationsAddApplicationNoteError = unknown;

export type PostApiLoanApplicationsAddLenderProfileNoteData = {
    body?: NotesData;
    query?: {
        lenderId?: string;
    };
};

export type PostApiLoanApplicationsAddLenderProfileNoteResponse = (unknown);

export type PostApiLoanApplicationsAddLenderProfileNoteError = unknown;

export type GetApiLoanApplicationsParticipatingLoanApplicationData = {
    query?: {
        loanAppId?: string;
    };
};

export type GetApiLoanApplicationsParticipatingLoanApplicationResponse = (LoanApplicationViewModel);

export type GetApiLoanApplicationsParticipatingLoanApplicationError = unknown;

export type GetApiLoanApplicationsGetProfileFilesData = {
    query?: {
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type GetApiLoanApplicationsGetProfileFilesResponse = (Array<FileViewModel>);

export type GetApiLoanApplicationsGetProfileFilesError = unknown;

export type GetApiLoanApplicationsGetLoanApplicationPreviewData = {
    query?: {
        email?: string;
        previewId?: string;
    };
};

export type GetApiLoanApplicationsGetLoanApplicationPreviewResponse = (LoanApplicationViewModel);

export type GetApiLoanApplicationsGetLoanApplicationPreviewError = unknown;

export type GetApiLoanApplicationsGetLoanApplicationData = {
    query?: {
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type GetApiLoanApplicationsGetLoanApplicationResponse = (LoanApplicationViewModel);

export type GetApiLoanApplicationsGetLoanApplicationError = unknown;

export type PostApiLoanApplicationsUpdateLenderSummaryData = {
    body?: LoanApplicationContentUpdateRequest;
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsUpdateLenderSummaryResponse = (unknown);

export type PostApiLoanApplicationsUpdateLenderSummaryError = unknown;

export type PostApiLoanApplicationsUpdateLoanCommentaryData = {
    body?: LoanApplicationContentUpdateRequest;
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsUpdateLoanCommentaryResponse = (unknown);

export type PostApiLoanApplicationsUpdateLoanCommentaryError = unknown;

export type PostApiLoanApplicationsUpdateLoanObjectiveData = {
    body?: LoanApplicationContentUpdateRequest;
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsUpdateLoanObjectiveResponse = (unknown);

export type PostApiLoanApplicationsUpdateLoanObjectiveError = unknown;

export type PostApiLoanApplicationsUpdateProbabilityOfCloseData = {
    query?: {
        loanId?: string;
        value?: number;
    };
};

export type PostApiLoanApplicationsUpdateProbabilityOfCloseResponse = (unknown);

export type PostApiLoanApplicationsUpdateProbabilityOfCloseError = unknown;

export type PostApiLoanApplicationsCreateLoanApplicationData = {
    body?: LoanApplicationViewModel;
    query?: {
        borrowerId?: string;
    };
};

export type PostApiLoanApplicationsCreateLoanApplicationResponse = (LoanApplicationViewModel);

export type PostApiLoanApplicationsCreateLoanApplicationError = unknown;

export type PostApiLoanApplicationsUpdateDiligenceStatusData = {
    query?: {
        loanAppId?: string;
        status?: DiligenceStatus;
    };
};

export type PostApiLoanApplicationsUpdateDiligenceStatusResponse = (unknown);

export type PostApiLoanApplicationsUpdateDiligenceStatusError = unknown;

export type PostApiLoanApplicationsApproveLoanData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsApproveLoanResponse = (unknown);

export type PostApiLoanApplicationsApproveLoanError = unknown;

export type GetApiLoanApplicationsDownloadBorrowerReviewFileData = {
    query?: {
        fileId?: string;
        loanAppId?: string;
    };
};

export type GetApiLoanApplicationsDownloadBorrowerReviewFileResponse = (unknown);

export type GetApiLoanApplicationsDownloadBorrowerReviewFileError = unknown;

export type GetApiLoanApplicationsGetCalculatedMatchedLendersData = {
    query?: {
        loanAppId?: string;
    };
};

export type GetApiLoanApplicationsGetCalculatedMatchedLendersResponse = (Array<LenderViewModel>);

export type GetApiLoanApplicationsGetCalculatedMatchedLendersError = unknown;

export type GetApiLoanApplicationsEngageableLendersData = {
    query?: {
        loanAppId?: string;
    };
};

export type GetApiLoanApplicationsEngageableLendersResponse = (Array<LenderViewModel>);

export type GetApiLoanApplicationsEngageableLendersError = unknown;

export type PostApiLoanApplicationsAssignSpecialistData = {
    query?: {
        loanAppId?: string;
        specialistId?: number;
    };
};

export type PostApiLoanApplicationsAssignSpecialistResponse = (unknown);

export type PostApiLoanApplicationsAssignSpecialistError = unknown;

export type PostApiLoanApplicationsAssignAdditionalLenderData = {
    query?: {
        lenderId?: string;
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsAssignAdditionalLenderResponse = (unknown);

export type PostApiLoanApplicationsAssignAdditionalLenderError = unknown;

export type PostApiLoanApplicationsAssignAdditionalLendersData = {
    body?: AdditionLenderAddRequest;
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsAssignAdditionalLendersResponse = (unknown);

export type PostApiLoanApplicationsAssignAdditionalLendersError = unknown;

export type PostApiLoanApplicationsWithdrawUnsubmittedLendersData = {
    query?: {
        loanAppId?: string;
    };
};

export type PostApiLoanApplicationsWithdrawUnsubmittedLendersResponse = (unknown);

export type PostApiLoanApplicationsWithdrawUnsubmittedLendersError = unknown;

export type GetApiLoanApplicationsGetTermSheetsData = {
    query?: {
        loanAppId?: string;
        portalType?: PortalType;
    };
};

export type GetApiLoanApplicationsGetTermSheetsResponse = (Array<LoanOfferViewModel>);

export type GetApiLoanApplicationsGetTermSheetsError = unknown;

export type GetApiOffersGetOffersForReviewData = {
    query?: {
        loanAppId?: string;
    };
};

export type GetApiOffersGetOffersForReviewResponse = (Array<LoanOfferViewModel>);

export type GetApiOffersGetOffersForReviewError = unknown;

export type PostApiOffersReturnOffersToLendersData = {
    body?: OfferList;
};

export type PostApiOffersReturnOffersToLendersResponse = (unknown);

export type PostApiOffersReturnOffersToLendersError = unknown;

export type PostApiOffersRenameOfferFileData = {
    query?: {
        fileId?: string;
        name?: string;
    };
};

export type PostApiOffersRenameOfferFileResponse = (unknown);

export type PostApiOffersRenameOfferFileError = unknown;

export type GetApiOffersDownloadOfferFileData = {
    query?: {
        fileId?: string;
        portalType?: PortalType;
    };
};

export type GetApiOffersDownloadOfferFileResponse = (unknown);

export type GetApiOffersDownloadOfferFileError = unknown;

export type PostApiOffersDeleteOfferFileData = {
    query?: {
        fileId?: string;
        portalType?: PortalType;
    };
};

export type PostApiOffersDeleteOfferFileResponse = (unknown);

export type PostApiOffersDeleteOfferFileError = unknown;

export type GetApiOffersGetOfferFilesData = {
    query?: {
        applicationId?: string;
        fileType?: LoanApplicationOfferFileStatus;
        offerId?: string;
        portalType?: PortalType;
    };
};

export type GetApiOffersGetOfferFilesResponse = (Array<FileViewModel>);

export type GetApiOffersGetOfferFilesError = unknown;

export type PostApiOffersApproveOffersData = {
    body?: OfferList;
};

export type PostApiOffersApproveOffersResponse = (unknown);

export type PostApiOffersApproveOffersError = unknown;

export type PostApiOffersUploadOfferFileData = {
    query?: {
        applicationId?: string;
        contentType?: string;
        fileName?: string;
        fileType?: LoanApplicationOfferFileStatus;
        offerId?: string;
        portalType?: PortalType;
    };
};

export type PostApiOffersUploadOfferFileResponse = (FileUploadResponse);

export type PostApiOffersUploadOfferFileError = unknown;

export type PostApiOffersSubmitNonBindingOfferData = {
    body?: LoanOfferViewModel;
    query?: {
        loanAppId?: string;
    };
};

export type PostApiOffersSubmitNonBindingOfferResponse = (unknown);

export type PostApiOffersSubmitNonBindingOfferError = unknown;

export type PostApiOffersSubmitBindingOfferData = {
    body?: LoanOfferViewModel;
    query?: {
        loanAppId?: string;
    };
};

export type PostApiOffersSubmitBindingOfferResponse = (unknown);

export type PostApiOffersSubmitBindingOfferError = unknown;

export type PostApiOffersAcceptLoanOfferData = {
    query?: {
        offerId?: string;
    };
};

export type PostApiOffersAcceptLoanOfferResponse = (unknown);

export type PostApiOffersAcceptLoanOfferError = unknown;

export type PostApiOffersDeclineLoanOfferData = {
    query?: {
        offerId?: string;
    };
};

export type PostApiOffersDeclineLoanOfferResponse = (unknown);

export type PostApiOffersDeclineLoanOfferError = unknown;

export type GetApiOffersDownloadOfferPackageData = {
    query?: {
        offerId?: string;
        portalType?: PortalType;
    };
};

export type GetApiOffersDownloadOfferPackageResponse = (unknown);

export type GetApiOffersDownloadOfferPackageError = unknown;

export type PostApiMessagesUploadMessageFileAttachmentsResponse = (Array<AttachmentViewModel>);

export type PostApiMessagesUploadMessageFileAttachmentsError = unknown;

export type GetApiMessagesDownloadLoanAppMessageAttachmentData = {
    query?: {
        attachmentId?: string;
        loanApplicationId?: string;
        messageId?: number;
        portalType?: PortalType;
    };
};

export type GetApiMessagesDownloadLoanAppMessageAttachmentResponse = (unknown);

export type GetApiMessagesDownloadLoanAppMessageAttachmentError = unknown;

export type GetApiMessagesGetLoanAppMessagesData = {
    query?: {
        loanApplicationId?: string;
        portalType?: PortalType;
    };
};

export type GetApiMessagesGetLoanAppMessagesResponse = (Array<MessageViewModel>);

export type GetApiMessagesGetLoanAppMessagesError = unknown;

export type PostApiMessagesSendLoanAppMessageData = {
    body?: SendMessageModel;
    query?: {
        loanApplicationId?: string;
        portalType?: PortalType;
    };
};

export type PostApiMessagesSendLoanAppMessageResponse = (unknown);

export type PostApiMessagesSendLoanAppMessageError = unknown;

export type PostApiPartnersUploadPartnerFileData = {
    query?: {
        contentType?: string;
        fileName?: string;
        partnerId?: string;
    };
};

export type PostApiPartnersUploadPartnerFileResponse = (FileUploadResponse);

export type PostApiPartnersUploadPartnerFileError = unknown;

export type PostApiPartnersDeletePartnerFileData = {
    query?: {
        fileId?: string;
        partnerId?: string;
    };
};

export type PostApiPartnersDeletePartnerFileResponse = (unknown);

export type PostApiPartnersDeletePartnerFileError = unknown;

export type PostApiPartnersDownloadPartnerFileData = {
    query?: {
        fileId?: string;
        partnerId?: string;
    };
};

export type PostApiPartnersDownloadPartnerFileResponse = (string);

export type PostApiPartnersDownloadPartnerFileError = unknown;

export type GetApiPartnersPartnerFilesData = {
    query?: {
        partnerId?: string;
    };
};

export type GetApiPartnersPartnerFilesResponse = (Array<FileViewModel>);

export type GetApiPartnersPartnerFilesError = unknown;

export type GetApiPartnersListResponse = (Array<PartnerViewModel>);

export type GetApiPartnersListError = unknown;

export type GetApiPartnersListLoansData = {
    query?: {
        partnerId?: string;
    };
};

export type GetApiPartnersListLoansResponse = (Array<LoanApplicationViewModel>);

export type GetApiPartnersListLoansError = unknown;

export type GetApiPartnersListGroupLoansData = {
    query?: {
        partnerGroupId?: string;
    };
};

export type GetApiPartnersListGroupLoansResponse = (Array<LoanApplicationViewModel>);

export type GetApiPartnersListGroupLoansError = unknown;

export type PostApiPartnersDeleteData = {
    query?: {
        partnerId?: string;
    };
};

export type PostApiPartnersDeleteResponse = (unknown);

export type PostApiPartnersDeleteError = unknown;

export type PostApiPartnersUpdateData = {
    body?: PartnerViewModel;
    query?: {
        partnerId?: string;
    };
};

export type PostApiPartnersUpdateResponse = (unknown);

export type PostApiPartnersUpdateError = unknown;

export type PostApiPartnersCreateData = {
    body?: PartnerViewModel;
};

export type PostApiPartnersCreateResponse = (unknown);

export type PostApiPartnersCreateError = unknown;

export type PostApiPartnersAddLoanToPartnerData = {
    query?: {
        loanId?: string;
        partnerId?: string;
    };
};

export type PostApiPartnersAddLoanToPartnerResponse = (unknown);

export type PostApiPartnersAddLoanToPartnerError = unknown;

export type PostApiPartnersRemoveLoanFromPartnerData = {
    query?: {
        loanId?: string;
        partnerId?: string;
    };
};

export type PostApiPartnersRemoveLoanFromPartnerResponse = (unknown);

export type PostApiPartnersRemoveLoanFromPartnerError = unknown;

export type PostApiPartnersCreatePartnerGroupData = {
    body?: PartnerGroupViewModel;
};

export type PostApiPartnersCreatePartnerGroupResponse = (unknown);

export type PostApiPartnersCreatePartnerGroupError = unknown;

export type PostApiPartnersUpdatePartnerGroupData = {
    body?: PartnerGroupViewModel;
    query?: {
        groupId?: string;
    };
};

export type PostApiPartnersUpdatePartnerGroupResponse = (unknown);

export type PostApiPartnersUpdatePartnerGroupError = unknown;

export type PostApiPartnersDeletePartnerGroupData = {
    query?: {
        groupId?: string;
    };
};

export type PostApiPartnersDeletePartnerGroupResponse = (unknown);

export type PostApiPartnersDeletePartnerGroupError = unknown;

export type PostApiPartnersAssignPartnerToGroupData = {
    query?: {
        groupId?: string;
        partnerId?: string;
    };
};

export type PostApiPartnersAssignPartnerToGroupResponse = (unknown);

export type PostApiPartnersAssignPartnerToGroupError = unknown;

export type GetApiPartnersGetPartnerGroupsResponse = (Array<PartnerGroupViewModel>);

export type GetApiPartnersGetPartnerGroupsError = unknown;

export type GetApiPartnersGetPartnerGroupData = {
    query?: {
        groupId?: string;
    };
};

export type GetApiPartnersGetPartnerGroupResponse = (PartnerGroupViewModel);

export type GetApiPartnersGetPartnerGroupError = unknown;

export type PostApiReferralsUploadReferralFilesResponse = (Array<FileViewModel>);

export type PostApiReferralsUploadReferralFilesError = unknown;

export type GetApiReferralsDownloadReferralPackageData = {
    query?: {
        referralId?: number;
    };
};

export type GetApiReferralsDownloadReferralPackageResponse = (unknown);

export type GetApiReferralsDownloadReferralPackageError = unknown;

export type PostApiReferralsSpecialistSubmitReferralData = {
    body?: ReferralData;
};

export type PostApiReferralsSpecialistSubmitReferralResponse = (unknown);

export type PostApiReferralsSpecialistSubmitReferralError = unknown;

export type PostApiReferralsSubmitReferralData = {
    body?: ReferralData;
};

export type PostApiReferralsSubmitReferralResponse = (unknown);

export type PostApiReferralsSubmitReferralError = unknown;

export type PostApiReferralsSetLoanAppReferralData = {
    query?: {
        loanAppId?: string;
        referralId?: number;
    };
};

export type PostApiReferralsSetLoanAppReferralResponse = (unknown);

export type PostApiReferralsSetLoanAppReferralError = unknown;

export type PostApiReferralsUpdateReferralStateData = {
    query?: {
        referralId?: number;
        state?: ReferralState;
    };
};

export type PostApiReferralsUpdateReferralStateResponse = (unknown);

export type PostApiReferralsUpdateReferralStateError = unknown;

export type PostApiReferralsUpdateReferralData = {
    body?: ReferralData;
    query?: {
        referralId?: number;
    };
};

export type PostApiReferralsUpdateReferralResponse = (unknown);

export type PostApiReferralsUpdateReferralError = unknown;

export type PostApiReferralsUpdateReferralDashboardNoteData = {
    query?: {
        id?: number;
        message?: string;
    };
};

export type PostApiReferralsUpdateReferralDashboardNoteResponse = (unknown);

export type PostApiReferralsUpdateReferralDashboardNoteError = unknown;

export type GetApiReferralsGetAllReferralsResponse = (Array<ReferralViewModel>);

export type GetApiReferralsGetAllReferralsError = unknown;

export type GetApiReferralsGetReferralsForLenderResponse = (Array<ReferralViewModel>);

export type GetApiReferralsGetReferralsForLenderError = unknown;

export type GetApiTemplatesEvaluateWithDefaultTemplateData = {
    query?: {
        loanAppId?: string;
    };
};

export type GetApiTemplatesEvaluateWithDefaultTemplateResponse = ({
    [key: string]: ITemplateResult;
});

export type GetApiTemplatesEvaluateWithDefaultTemplateError = unknown;

export type PostApiTemplatesRecommendGenericLoanTypeData = {
    body?: LoanAsk;
};

export type PostApiTemplatesRecommendGenericLoanTypeResponse = (LoanType);

export type PostApiTemplatesRecommendGenericLoanTypeError = unknown;

export type GetApiTemplatesEvaluateRsgDashboardResponse = ({
    [key: string]: ITemplateResult;
});

export type GetApiTemplatesEvaluateRsgDashboardError = unknown;

export type GetApiTemplatesEvaluateWithTemplateData = {
    query?: {
        loanAppId?: string;
        templateId?: string;
    };
};

export type GetApiTemplatesEvaluateWithTemplateResponse = ({
    [key: string]: ITemplateResult;
});

export type GetApiTemplatesEvaluateWithTemplateError = unknown;

export type GetApiTemplatesListResponse = (Array<LenderTemplateViewModel>);

export type GetApiTemplatesListError = unknown;

export type GetApiTemplatesTemplateMapResponse = ({
    [key: string]: TemplateType;
});

export type GetApiTemplatesTemplateMapError = unknown;

export type PostApiTemplatesValidateCustomMetricFormulaData = {
    body?: FormulaValidationRequest;
};

export type PostApiTemplatesValidateCustomMetricFormulaResponse = (ValidationResponse);

export type PostApiTemplatesValidateCustomMetricFormulaError = unknown;

export type GetApiTemplatesCustomMetricsResponse = (Array<LenderCustomMetricViewModel>);

export type GetApiTemplatesCustomMetricsError = unknown;

export type PostApiTemplatesCreateCustomMetricData = {
    query?: {
        name?: string;
    };
};

export type PostApiTemplatesCreateCustomMetricResponse = (LenderCustomMetricViewModel);

export type PostApiTemplatesCreateCustomMetricError = unknown;

export type PostApiTemplatesUpdateCustomMetricData = {
    body?: LenderCustomMetricViewModel;
};

export type PostApiTemplatesUpdateCustomMetricResponse = (unknown);

export type PostApiTemplatesUpdateCustomMetricError = unknown;

export type PostApiTemplatesDeleteCustomMetricData = {
    body?: LenderCustomMetricViewModel;
};

export type PostApiTemplatesDeleteCustomMetricResponse = (unknown);

export type PostApiTemplatesDeleteCustomMetricError = unknown;

export type PostApiTemplatesCreateData = {
    query?: {
        name?: string;
    };
};

export type PostApiTemplatesCreateResponse = (string);

export type PostApiTemplatesCreateError = unknown;

export type PostApiTemplatesUpdateData = {
    body?: LenderTemplateViewModel;
    query?: {
        id?: string;
    };
};

export type PostApiTemplatesUpdateResponse = (unknown);

export type PostApiTemplatesUpdateError = unknown;

export type PostApiTemplatesDeleteData = {
    query?: {
        id?: string;
    };
};

export type PostApiTemplatesDeleteResponse = (unknown);

export type PostApiTemplatesDeleteError = unknown;

export type GetApiUsersAllResponse = (Array<UserViewModel>);

export type GetApiUsersAllError = unknown;

export type GetApiUsersNotificationsData = {
    query?: {
        portalType?: PortalType;
    };
};

export type GetApiUsersNotificationsResponse = (Array<NotificationViewModel>);

export type GetApiUsersNotificationsError = unknown;

export type PostApiUsersDismissAllNotificationsData = {
    query?: {
        portalType?: PortalType;
    };
};

export type PostApiUsersDismissAllNotificationsResponse = (unknown);

export type PostApiUsersDismissAllNotificationsError = unknown;

export type GetApiUsersUserHistoryData = {
    query?: {
        userId?: number;
    };
};

export type GetApiUsersUserHistoryResponse = (Array<AuditViewModel>);

export type GetApiUsersUserHistoryError = unknown;

export type GetApiUsersGetFullAuditExportResponse = (unknown);

export type GetApiUsersGetFullAuditExportError = unknown;

export type GetApiUsersUserLendersData = {
    query?: {
        userId?: number;
    };
};

export type GetApiUsersUserLendersResponse = (Array<LenderViewModel>);

export type GetApiUsersUserLendersError = unknown;

export type GetApiUsersUserBorrowersData = {
    query?: {
        userId?: number;
    };
};

export type GetApiUsersUserBorrowersResponse = (Array<BorrowerViewModel>);

export type GetApiUsersUserBorrowersError = unknown;

export type GetApiUsersLenderContextResponse = (LenderContextViewModel);

export type GetApiUsersLenderContextError = unknown;

export type GetApiUsersBorrowerContextResponse = (BorrowerContextViewModel);

export type GetApiUsersBorrowerContextError = unknown;

export type GetApiUsersMeResponse = (UserViewModel);

export type GetApiUsersMeError = unknown;

export type PostApiUsersUpdateProfileData = {
    body?: UserViewModel;
};

export type PostApiUsersUpdateProfileResponse = (unknown);

export type PostApiUsersUpdateProfileError = unknown;

export type GetApiUsersGetSpecialistUsersResponse = (Array<UserViewModel>);

export type GetApiUsersGetSpecialistUsersError = unknown;

export type GetApiUsersUserActivityData = {
    query?: {
        userId?: number;
    };
};

export type GetApiUsersUserActivityResponse = (Array<AuditViewModel>);

export type GetApiUsersUserActivityError = unknown;

export type PostApiUsersInviteData = {
    body?: InviteUserRequest;
};

export type PostApiUsersInviteResponse = (UserViewModel);

export type PostApiUsersInviteError = unknown;